webpackJsonp([1,4],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./accordion": 4,
		"./accordion.js": 4,
		"./carousel": 6,
		"./carousel.js": 6,
		"./confirm": 8,
		"./confirm.js": 8,
		"./contact-form": 9,
		"./contact-form-BE": 11,
		"./contact-form-BE-v2": 12,
		"./contact-form-BE-v2.js": 12,
		"./contact-form-BE.js": 11,
		"./contact-form-v2": 13,
		"./contact-form-v2.js": 13,
		"./contact-form.js": 9,
		"./filter": 15,
		"./filter.js": 15,
		"./modal": 16,
		"./modal.js": 16,
		"./tabs": 17,
		"./tabs.js": 17,
		"./two-col-vertically-stacked-tiles": 18,
		"./two-col-vertically-stacked-tiles.js": 18,
		"./video-tile": 19,
		"./video-tile.js": 19
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 3;


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	var Module_Accordion = (function (_Abstract2) {
	    _inherits(Module_Accordion, _Abstract2);
	
	    function Module_Accordion(el, options) {
	        _classCallCheck(this, Module_Accordion);
	
	        _get(Object.getPrototypeOf(Module_Accordion.prototype), "constructor", this).call(this, el, $.extend(true, {}, options), 'module');
	        this.initModule();
	    }
	
	    _createClass(Module_Accordion, [{
	        key: "initModule",
	        value: function initModule() {
	            var $accordianItems = this.$el.find(".m-accordion__item");
	            var $accordianLinks = this.$el.find(".m-accordion__title");
	            var $accordianContent;
	
	            $accordianLinks.on("click", function () {
	                var $accordianItem = $(this).closest(".m-accordion__item");
	                $accordianItems.not($accordianItem).removeClass("is-open");
	                if ($accordianItem.hasClass("is-open")) {
	                    $accordianItem.removeClass("is-open");
	                } else {
	                    $accordianItem.addClass("is-open");
	                }
	            });
	        }
	    }]);
	
	    return Module_Accordion;
	})(_systemAbstract2["default"]);
	
	exports["default"] = Module_Accordion;
	module.exports = exports["default"];

/***/ },
/* 5 */,
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	var HammerJS = __webpack_require__(7);
	
	var Module_Carousel = (function (_Abstract2) {
		_inherits(Module_Carousel, _Abstract2);
	
		function Module_Carousel(el, options) {
			_classCallCheck(this, Module_Carousel);
	
			_get(Object.getPrototypeOf(Module_Carousel.prototype), "constructor", this).call(this, el, $.extend(true, {}, options), 'module');
			this.initModule();
		}
	
		/********* Initialising ***************/
	
		_createClass(Module_Carousel, [{
			key: "initModule",
			value: function initModule() {
				if (this.$el.hasClass("-with-description-block")) {
					// this.$el.wrap("<div class='m-carousel-wrap'></div>");
					this.$el.addClass("-one-col-right-offset");
				}
				// m-carousel  -with-description-block
	
				this.$imageSliderContainer = this.$el.find(".c-image-slider");
				if (!this.$imageSliderContainer.length) {
					console.log("No instances of image Slider Container Found");
					return;
				}
	
				this.m_bIsTextUnderneathCarousel = this.$el.hasClass("-with-description-underneath-block");
				this.checkSpacingForCTAs();
				this.swipedBeforeClick = false;
				this.$imageSliderUL = this.$imageSliderContainer.find("ul");
				this.$imageSliderUL.find("> li").removeClass("-hide");
	
				if (!this.$imageSliderUL.find("> li").length) {
					console.log("No Items able to be used for carousel");
					return;
				}
	
				this.initialiseImageReverseIfDefined();
				this.initialiseNavigationDots();
				this.$carouselCircleContainer = this.$el.find(".c-carousel-circle-ctn");
				this.$carouselCircles = this.$carouselCircleContainer.find(".c-carousel-circle");
	
				if (this.getTotalSlides() === 1) {
					this.$el.find(".c-image-slider-navigate-btn").remove();
					this.$carouselCircleContainer.remove();
					this.$el.addClass("-no-slide");
				} else {
					if (this.$el.hasClass("-reverse")) {
						this.activateCarouselIndex(this.getTotalSlides() - 1, false); //Just to make sure everything has the right class etc
					} else {
							this.activateCarouselIndex(0, false); //Just to make sure everything has the right class etc
						}
	
					this.initialiseHammer();
					this.initListeners();
					// this.rePositionSliderButtonsIfNeeded();
				}
	
				this.onWindowResize();
			}
		}, {
			key: "initialiseHammer",
			value: function initialiseHammer() {
				if (typeof Hammer === "undefined" || typeof Hammer.Manager !== "function") {
					console.log("Failed to initialise Carousel Module with Swipe detection due to no Hammer.js, please make sure you have this installed to support swipe gestures");
					return;
				}
	
				var hammerOptions = {
					touchAction: 'auto' //Enables vertical scrolling, as sometimes the carousel fills the whole screen, and the user cant scroll down the page!
				};
	
				this.hammer = new Hammer.Manager(this.$imageSliderContainer[0], hammerOptions);
				var hammerSwipe = new Hammer.Swipe();
				this.hammer.add(hammerSwipe);
			}
		}, {
			key: "initListeners",
			value: function initListeners() {
				var _this = this;
	
				this.$el.find(".c-carousel-circle-ctn").on("click", "li", function (e) {
					return _this.onCircleContainerClicked(e);
				});
	
				this.$el.on("click", ".c-image-slider-navigate-btn-ctn .c-image-slider-navigate-btn.-back", function (e) {
					return _this.onNavigateBackClicked();
				});
				this.$el.on("click", ".c-image-slider-navigate-btn-ctn .c-image-slider-navigate-btn.-next", function (e) {
					return _this.onNavigateNextClicked();
				});
	
				this.hammer.on('swipeleft', function () {
					return _this.onSwipeLeft();
				});
				this.hammer.on('swiperight', function () {
					return _this.onSwipeRight();
				});
	
				$(window).resize(function () {
					return _this.onWindowResize();
				});
				this.$el.find(".c-image-slider").on("click", "> ul > li [data-tap-through-url]", function (e) {
					return _this.onLiTileClicked(e);
				});
			}
		}, {
			key: "onLiTileClicked",
			value: function onLiTileClicked(e) {
				if (this.swipedBeforeClick) {
					this.swipedBeforeClick = false;
					return;
				}
	
				//Internet explorer has issues with an a tag around a carousel item (and using hammer js)
				//So we'll just use a data tag to decide where to navigate to
				var tapThroughURL = $(e.currentTarget).data("tap-through-url");
	
				if (!tapThroughURL) {
					return;
				}
	
				window.location = tapThroughURL;
			}
		}, {
			key: "checkSpacingForCTAs",
			value: function checkSpacingForCTAs() {
				var numCTAs = this.$el.find(".c-image-slider-cta").length;
				if (numCTAs) {
					return;
				}
	
				this.$el.addClass("no-ctas");
			}
		}, {
			key: "initialiseNavigationDots",
			value: function initialiseNavigationDots() {
				if (this.$el.find(".c-carousel-circle-ctn").length) {
					return;
				}
	
				var carouselCircleHTML = this.getCarouselCircleHTML();
	
				this.$el.append(carouselCircleHTML);
			}
		}, {
			key: "initialiseImageReverseIfDefined",
			value: function initialiseImageReverseIfDefined() {
				if (!this.$el.hasClass("-reverse")) {
					return;
				}
	
				this.reverseCarouselItems();
			}
		}, {
			key: "reverseCarouselItems",
			value: function reverseCarouselItems() {
				var $imageSliderUL = this.$imageSliderUL;
				$imageSliderUL.children().each(function () {
					$imageSliderUL.prepend(this);
				});
			}
		}, {
			key: "getCarouselCircleHTML",
			value: function getCarouselCircleHTML() {
				var html = "";
				html += '<div class="content-margin  -hide-for-print">';
				html += '	<ul class="c-carousel-circle-ctn">';
	
				var numCarouselItems = this.getTotalSlides();
				for (var i = 0; i < numCarouselItems; ++i) {
					var classes = "";
					if (i === 0) {
						classes += " -active ";
					}
					html += '		<li><div class="c-carousel-circle ' + classes + '"></div></li>';
				}
				html += '	</ul>';
				html += '</div>';
	
				return html;
			}
	
			/********* Responding to Events ***************/
	
		}, {
			key: "onWindowResize",
			value: function onWindowResize() {
	
				this.rePositionSliderButtonsIfNeeded();
				this.reAlignSlides();
			}
		}, {
			key: "rePositionSliderButtonsIfNeeded",
			value: function rePositionSliderButtonsIfNeeded() {
				if (!this.m_bIsTextUnderneathCarousel) {
					return;
				}
	
				// if()
	
				var desktopBreakpointSize = $("#bp-desktop").width();
				var bDesktop = $(window).outerWidth() >= desktopBreakpointSize;
				var $tiles = this.$el.find(".c-image-slider > ul .c-tile");
				$tiles.removeAttr("style");
				if (bDesktop) {
	
					var currentTileHeight = $tiles.height();
					var width = currentTileHeight * 1.54;
					$tiles.css({ width: width });
					this.$el.find(".c-image-slider > ul > li").css({ width: width });
	
					var ulHeight = $(".-with-description-underneath-block .c-image-slider .c-tile ").height();
					var marginTop = parseInt($(".-underneath-carousel-block").css("margin-top"));
					this.$carouselCircleContainer.css({ top: ulHeight + marginTop + "px" });
				} else {
					this.$el.find(".c-image-slider > ul > li").removeAttr("style");
					this.$carouselCircleContainer.removeAttr("style");
	
					var cTileHeight = this.$el.find(".c-tile").height();
	
					this.$carouselCircleContainer.css({ top: cTileHeight + "px", position: "absolute" });
				}
			}
		}, {
			key: "onNavigateBackClicked",
			value: function onNavigateBackClicked() {
				this.onSlideCarouselLeft();
			}
		}, {
			key: "onNavigateNextClicked",
			value: function onNavigateNextClicked() {
				this.onSlideCarouselRight();
			}
		}, {
			key: "onSwipeLeft",
			value: function onSwipeLeft() {
				this.swipedBeforeClick = true;
				console.log("swipe left");
				this.onSlideCarouselRight();
			}
		}, {
			key: "onSwipeRight",
			value: function onSwipeRight() {
				this.swipedBeforeClick = true;
				console.log("swipe right");
				this.onSlideCarouselLeft();
			}
		}, {
			key: "onCircleContainerClicked",
			value: function onCircleContainerClicked(_mouseEvent) {
	
				var $currentTarget = $(_mouseEvent.currentTarget);
				var carouselButtonIndex = $currentTarget.index();
				this.activateCarouselIndex(carouselButtonIndex);
			}
	
			/********* Changing or reading carousel state ***************/
	
		}, {
			key: "reAlignSlides",
			value: function reAlignSlides() {
				var animateRealignment = false;
				this.activateCarouselIndex(this.getCurrentCarouselIndex(), animateRealignment);
			}
		}, {
			key: "getTotalSlides",
			value: function getTotalSlides() {
				// var totalSlides = this.$carouselCircles.length;
				var totalSlides = this.$imageSliderUL.find("> li:not(.-faker)").length;
				return totalSlides;
			}
		}, {
			key: "getCurrentCarouselIndex",
			value: function getCurrentCarouselIndex() {
				// var carouselIndex = this.$el.find(".c-carousel-circle.-active").parent().index();
				var carouselIndex = -1;
				var activeCarouselIndex = -1;
				this.$imageSliderUL.find("> li").each(function () {
					if ($(this).hasClass("-faker")) {
						return;
					}
					++carouselIndex;
	
					if ($(this).hasClass("-active")) {
						activeCarouselIndex = carouselIndex;
						return false;
					}
				});
	
				// var carouselIndex = this.$imageSliderUL.find("> li.-active").index();
				return activeCarouselIndex;
			}
		}, {
			key: "onSlideCarouselRight",
			value: function onSlideCarouselRight() {
				var goToIndex = this.getCurrentCarouselIndex() + 1;
				if (goToIndex >= this.getTotalSlides()) {
					goToIndex = 0;
				}
	
				this.activateCarouselIndex(goToIndex);
			}
		}, {
			key: "onSlideCarouselLeft",
			value: function onSlideCarouselLeft() {
				var goToIndex = this.getCurrentCarouselIndex() - 1;
				if (goToIndex < 0) {
					goToIndex = this.getTotalSlides() - 1;
				}
	
				this.activateCarouselIndex(goToIndex);
			}
		}, {
			key: "activateCarouselIndex",
			value: function activateCarouselIndex(_index, _animateAlignment) {
				if (typeof _animateAlignment === "undefined") {
					_animateAlignment = true;
				}
	
				this.$carouselCircles.removeClass("-active");
				this.$carouselCircles.eq(_index).addClass("-active");
	
				var $carouselSliderLiItems = this.$imageSliderUL.find("> li:not(.-faker)");
				var $activeCarouselItem = $carouselSliderLiItems.eq(_index);
	
				if (!$activeCarouselItem.length) {
					return;
				}
	
				$carouselSliderLiItems.removeClass("-active");
				$activeCarouselItem.addClass("-active");
	
				var carouselWidth = this.$el.width();
				// var offsetWidthOriginal = carouselWidth*_index;
				var offsetWidth = $activeCarouselItem.position().left;
				this.$imageSliderUL.stop(true);
	
				var cssOffsetObject = { left: -offsetWidth + "px" };
				if (_animateAlignment) {
					this.$imageSliderUL.animate(cssOffsetObject);
				} else {
					this.$imageSliderUL.css(cssOffsetObject);
				}
			}
		}]);
	
		return Module_Carousel;
	})(_systemAbstract2["default"]);
	
	exports["default"] = Module_Carousel;
	module.exports = exports["default"];

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
	 * http://hammerjs.github.io/
	 *
	 * Copyright (c) 2016 Jorik Tangelder;
	 * Licensed under the MIT license */
	!function(a,b,c,d){"use strict";function e(a,b,c){return setTimeout(j(a,c),b)}function f(a,b,c){return Array.isArray(a)?(g(a,c[b],c),!0):!1}function g(a,b,c){var e;if(a)if(a.forEach)a.forEach(b,c);else if(a.length!==d)for(e=0;e<a.length;)b.call(c,a[e],e,a),e++;else for(e in a)a.hasOwnProperty(e)&&b.call(c,a[e],e,a)}function h(b,c,d){var e="DEPRECATED METHOD: "+c+"\n"+d+" AT \n";return function(){var c=new Error("get-stack-trace"),d=c&&c.stack?c.stack.replace(/^[^\(]+?[\n$]/gm,"").replace(/^\s+at\s+/gm,"").replace(/^Object.<anonymous>\s*\(/gm,"{anonymous}()@"):"Unknown Stack Trace",f=a.console&&(a.console.warn||a.console.log);return f&&f.call(a.console,e,d),b.apply(this,arguments)}}function i(a,b,c){var d,e=b.prototype;d=a.prototype=Object.create(e),d.constructor=a,d._super=e,c&&la(d,c)}function j(a,b){return function(){return a.apply(b,arguments)}}function k(a,b){return typeof a==oa?a.apply(b?b[0]||d:d,b):a}function l(a,b){return a===d?b:a}function m(a,b,c){g(q(b),function(b){a.addEventListener(b,c,!1)})}function n(a,b,c){g(q(b),function(b){a.removeEventListener(b,c,!1)})}function o(a,b){for(;a;){if(a==b)return!0;a=a.parentNode}return!1}function p(a,b){return a.indexOf(b)>-1}function q(a){return a.trim().split(/\s+/g)}function r(a,b,c){if(a.indexOf&&!c)return a.indexOf(b);for(var d=0;d<a.length;){if(c&&a[d][c]==b||!c&&a[d]===b)return d;d++}return-1}function s(a){return Array.prototype.slice.call(a,0)}function t(a,b,c){for(var d=[],e=[],f=0;f<a.length;){var g=b?a[f][b]:a[f];r(e,g)<0&&d.push(a[f]),e[f]=g,f++}return c&&(d=b?d.sort(function(a,c){return a[b]>c[b]}):d.sort()),d}function u(a,b){for(var c,e,f=b[0].toUpperCase()+b.slice(1),g=0;g<ma.length;){if(c=ma[g],e=c?c+f:b,e in a)return e;g++}return d}function v(){return ua++}function w(b){var c=b.ownerDocument||b;return c.defaultView||c.parentWindow||a}function x(a,b){var c=this;this.manager=a,this.callback=b,this.element=a.element,this.target=a.options.inputTarget,this.domHandler=function(b){k(a.options.enable,[a])&&c.handler(b)},this.init()}function y(a){var b,c=a.options.inputClass;return new(b=c?c:xa?M:ya?P:wa?R:L)(a,z)}function z(a,b,c){var d=c.pointers.length,e=c.changedPointers.length,f=b&Ea&&d-e===0,g=b&(Ga|Ha)&&d-e===0;c.isFirst=!!f,c.isFinal=!!g,f&&(a.session={}),c.eventType=b,A(a,c),a.emit("hammer.input",c),a.recognize(c),a.session.prevInput=c}function A(a,b){var c=a.session,d=b.pointers,e=d.length;c.firstInput||(c.firstInput=D(b)),e>1&&!c.firstMultiple?c.firstMultiple=D(b):1===e&&(c.firstMultiple=!1);var f=c.firstInput,g=c.firstMultiple,h=g?g.center:f.center,i=b.center=E(d);b.timeStamp=ra(),b.deltaTime=b.timeStamp-f.timeStamp,b.angle=I(h,i),b.distance=H(h,i),B(c,b),b.offsetDirection=G(b.deltaX,b.deltaY);var j=F(b.deltaTime,b.deltaX,b.deltaY);b.overallVelocityX=j.x,b.overallVelocityY=j.y,b.overallVelocity=qa(j.x)>qa(j.y)?j.x:j.y,b.scale=g?K(g.pointers,d):1,b.rotation=g?J(g.pointers,d):0,b.maxPointers=c.prevInput?b.pointers.length>c.prevInput.maxPointers?b.pointers.length:c.prevInput.maxPointers:b.pointers.length,C(c,b);var k=a.element;o(b.srcEvent.target,k)&&(k=b.srcEvent.target),b.target=k}function B(a,b){var c=b.center,d=a.offsetDelta||{},e=a.prevDelta||{},f=a.prevInput||{};b.eventType!==Ea&&f.eventType!==Ga||(e=a.prevDelta={x:f.deltaX||0,y:f.deltaY||0},d=a.offsetDelta={x:c.x,y:c.y}),b.deltaX=e.x+(c.x-d.x),b.deltaY=e.y+(c.y-d.y)}function C(a,b){var c,e,f,g,h=a.lastInterval||b,i=b.timeStamp-h.timeStamp;if(b.eventType!=Ha&&(i>Da||h.velocity===d)){var j=b.deltaX-h.deltaX,k=b.deltaY-h.deltaY,l=F(i,j,k);e=l.x,f=l.y,c=qa(l.x)>qa(l.y)?l.x:l.y,g=G(j,k),a.lastInterval=b}else c=h.velocity,e=h.velocityX,f=h.velocityY,g=h.direction;b.velocity=c,b.velocityX=e,b.velocityY=f,b.direction=g}function D(a){for(var b=[],c=0;c<a.pointers.length;)b[c]={clientX:pa(a.pointers[c].clientX),clientY:pa(a.pointers[c].clientY)},c++;return{timeStamp:ra(),pointers:b,center:E(b),deltaX:a.deltaX,deltaY:a.deltaY}}function E(a){var b=a.length;if(1===b)return{x:pa(a[0].clientX),y:pa(a[0].clientY)};for(var c=0,d=0,e=0;b>e;)c+=a[e].clientX,d+=a[e].clientY,e++;return{x:pa(c/b),y:pa(d/b)}}function F(a,b,c){return{x:b/a||0,y:c/a||0}}function G(a,b){return a===b?Ia:qa(a)>=qa(b)?0>a?Ja:Ka:0>b?La:Ma}function H(a,b,c){c||(c=Qa);var d=b[c[0]]-a[c[0]],e=b[c[1]]-a[c[1]];return Math.sqrt(d*d+e*e)}function I(a,b,c){c||(c=Qa);var d=b[c[0]]-a[c[0]],e=b[c[1]]-a[c[1]];return 180*Math.atan2(e,d)/Math.PI}function J(a,b){return I(b[1],b[0],Ra)+I(a[1],a[0],Ra)}function K(a,b){return H(b[0],b[1],Ra)/H(a[0],a[1],Ra)}function L(){this.evEl=Ta,this.evWin=Ua,this.pressed=!1,x.apply(this,arguments)}function M(){this.evEl=Xa,this.evWin=Ya,x.apply(this,arguments),this.store=this.manager.session.pointerEvents=[]}function N(){this.evTarget=$a,this.evWin=_a,this.started=!1,x.apply(this,arguments)}function O(a,b){var c=s(a.touches),d=s(a.changedTouches);return b&(Ga|Ha)&&(c=t(c.concat(d),"identifier",!0)),[c,d]}function P(){this.evTarget=bb,this.targetIds={},x.apply(this,arguments)}function Q(a,b){var c=s(a.touches),d=this.targetIds;if(b&(Ea|Fa)&&1===c.length)return d[c[0].identifier]=!0,[c,c];var e,f,g=s(a.changedTouches),h=[],i=this.target;if(f=c.filter(function(a){return o(a.target,i)}),b===Ea)for(e=0;e<f.length;)d[f[e].identifier]=!0,e++;for(e=0;e<g.length;)d[g[e].identifier]&&h.push(g[e]),b&(Ga|Ha)&&delete d[g[e].identifier],e++;return h.length?[t(f.concat(h),"identifier",!0),h]:void 0}function R(){x.apply(this,arguments);var a=j(this.handler,this);this.touch=new P(this.manager,a),this.mouse=new L(this.manager,a),this.primaryTouch=null,this.lastTouches=[]}function S(a,b){a&Ea?(this.primaryTouch=b.changedPointers[0].identifier,T.call(this,b)):a&(Ga|Ha)&&T.call(this,b)}function T(a){var b=a.changedPointers[0];if(b.identifier===this.primaryTouch){var c={x:b.clientX,y:b.clientY};this.lastTouches.push(c);var d=this.lastTouches,e=function(){var a=d.indexOf(c);a>-1&&d.splice(a,1)};setTimeout(e,cb)}}function U(a){for(var b=a.srcEvent.clientX,c=a.srcEvent.clientY,d=0;d<this.lastTouches.length;d++){var e=this.lastTouches[d],f=Math.abs(b-e.x),g=Math.abs(c-e.y);if(db>=f&&db>=g)return!0}return!1}function V(a,b){this.manager=a,this.set(b)}function W(a){if(p(a,jb))return jb;var b=p(a,kb),c=p(a,lb);return b&&c?jb:b||c?b?kb:lb:p(a,ib)?ib:hb}function X(){if(!fb)return!1;var b={},c=a.CSS&&a.CSS.supports;return["auto","manipulation","pan-y","pan-x","pan-x pan-y","none"].forEach(function(d){b[d]=c?a.CSS.supports("touch-action",d):!0}),b}function Y(a){this.options=la({},this.defaults,a||{}),this.id=v(),this.manager=null,this.options.enable=l(this.options.enable,!0),this.state=nb,this.simultaneous={},this.requireFail=[]}function Z(a){return a&sb?"cancel":a&qb?"end":a&pb?"move":a&ob?"start":""}function $(a){return a==Ma?"down":a==La?"up":a==Ja?"left":a==Ka?"right":""}function _(a,b){var c=b.manager;return c?c.get(a):a}function aa(){Y.apply(this,arguments)}function ba(){aa.apply(this,arguments),this.pX=null,this.pY=null}function ca(){aa.apply(this,arguments)}function da(){Y.apply(this,arguments),this._timer=null,this._input=null}function ea(){aa.apply(this,arguments)}function fa(){aa.apply(this,arguments)}function ga(){Y.apply(this,arguments),this.pTime=!1,this.pCenter=!1,this._timer=null,this._input=null,this.count=0}function ha(a,b){return b=b||{},b.recognizers=l(b.recognizers,ha.defaults.preset),new ia(a,b)}function ia(a,b){this.options=la({},ha.defaults,b||{}),this.options.inputTarget=this.options.inputTarget||a,this.handlers={},this.session={},this.recognizers=[],this.oldCssProps={},this.element=a,this.input=y(this),this.touchAction=new V(this,this.options.touchAction),ja(this,!0),g(this.options.recognizers,function(a){var b=this.add(new a[0](a[1]));a[2]&&b.recognizeWith(a[2]),a[3]&&b.requireFailure(a[3])},this)}function ja(a,b){var c=a.element;if(c.style){var d;g(a.options.cssProps,function(e,f){d=u(c.style,f),b?(a.oldCssProps[d]=c.style[d],c.style[d]=e):c.style[d]=a.oldCssProps[d]||""}),b||(a.oldCssProps={})}}function ka(a,c){var d=b.createEvent("Event");d.initEvent(a,!0,!0),d.gesture=c,c.target.dispatchEvent(d)}var la,ma=["","webkit","Moz","MS","ms","o"],na=b.createElement("div"),oa="function",pa=Math.round,qa=Math.abs,ra=Date.now;la="function"!=typeof Object.assign?function(a){if(a===d||null===a)throw new TypeError("Cannot convert undefined or null to object");for(var b=Object(a),c=1;c<arguments.length;c++){var e=arguments[c];if(e!==d&&null!==e)for(var f in e)e.hasOwnProperty(f)&&(b[f]=e[f])}return b}:Object.assign;var sa=h(function(a,b,c){for(var e=Object.keys(b),f=0;f<e.length;)(!c||c&&a[e[f]]===d)&&(a[e[f]]=b[e[f]]),f++;return a},"extend","Use `assign`."),ta=h(function(a,b){return sa(a,b,!0)},"merge","Use `assign`."),ua=1,va=/mobile|tablet|ip(ad|hone|od)|android/i,wa="ontouchstart"in a,xa=u(a,"PointerEvent")!==d,ya=wa&&va.test(navigator.userAgent),za="touch",Aa="pen",Ba="mouse",Ca="kinect",Da=25,Ea=1,Fa=2,Ga=4,Ha=8,Ia=1,Ja=2,Ka=4,La=8,Ma=16,Na=Ja|Ka,Oa=La|Ma,Pa=Na|Oa,Qa=["x","y"],Ra=["clientX","clientY"];x.prototype={handler:function(){},init:function(){this.evEl&&m(this.element,this.evEl,this.domHandler),this.evTarget&&m(this.target,this.evTarget,this.domHandler),this.evWin&&m(w(this.element),this.evWin,this.domHandler)},destroy:function(){this.evEl&&n(this.element,this.evEl,this.domHandler),this.evTarget&&n(this.target,this.evTarget,this.domHandler),this.evWin&&n(w(this.element),this.evWin,this.domHandler)}};var Sa={mousedown:Ea,mousemove:Fa,mouseup:Ga},Ta="mousedown",Ua="mousemove mouseup";i(L,x,{handler:function(a){var b=Sa[a.type];b&Ea&&0===a.button&&(this.pressed=!0),b&Fa&&1!==a.which&&(b=Ga),this.pressed&&(b&Ga&&(this.pressed=!1),this.callback(this.manager,b,{pointers:[a],changedPointers:[a],pointerType:Ba,srcEvent:a}))}});var Va={pointerdown:Ea,pointermove:Fa,pointerup:Ga,pointercancel:Ha,pointerout:Ha},Wa={2:za,3:Aa,4:Ba,5:Ca},Xa="pointerdown",Ya="pointermove pointerup pointercancel";a.MSPointerEvent&&!a.PointerEvent&&(Xa="MSPointerDown",Ya="MSPointerMove MSPointerUp MSPointerCancel"),i(M,x,{handler:function(a){var b=this.store,c=!1,d=a.type.toLowerCase().replace("ms",""),e=Va[d],f=Wa[a.pointerType]||a.pointerType,g=f==za,h=r(b,a.pointerId,"pointerId");e&Ea&&(0===a.button||g)?0>h&&(b.push(a),h=b.length-1):e&(Ga|Ha)&&(c=!0),0>h||(b[h]=a,this.callback(this.manager,e,{pointers:b,changedPointers:[a],pointerType:f,srcEvent:a}),c&&b.splice(h,1))}});var Za={touchstart:Ea,touchmove:Fa,touchend:Ga,touchcancel:Ha},$a="touchstart",_a="touchstart touchmove touchend touchcancel";i(N,x,{handler:function(a){var b=Za[a.type];if(b===Ea&&(this.started=!0),this.started){var c=O.call(this,a,b);b&(Ga|Ha)&&c[0].length-c[1].length===0&&(this.started=!1),this.callback(this.manager,b,{pointers:c[0],changedPointers:c[1],pointerType:za,srcEvent:a})}}});var ab={touchstart:Ea,touchmove:Fa,touchend:Ga,touchcancel:Ha},bb="touchstart touchmove touchend touchcancel";i(P,x,{handler:function(a){var b=ab[a.type],c=Q.call(this,a,b);c&&this.callback(this.manager,b,{pointers:c[0],changedPointers:c[1],pointerType:za,srcEvent:a})}});var cb=2500,db=25;i(R,x,{handler:function(a,b,c){var d=c.pointerType==za,e=c.pointerType==Ba;if(!(e&&c.sourceCapabilities&&c.sourceCapabilities.firesTouchEvents)){if(d)S.call(this,b,c);else if(e&&U.call(this,c))return;this.callback(a,b,c)}},destroy:function(){this.touch.destroy(),this.mouse.destroy()}});var eb=u(na.style,"touchAction"),fb=eb!==d,gb="compute",hb="auto",ib="manipulation",jb="none",kb="pan-x",lb="pan-y",mb=X();V.prototype={set:function(a){a==gb&&(a=this.compute()),fb&&this.manager.element.style&&mb[a]&&(this.manager.element.style[eb]=a),this.actions=a.toLowerCase().trim()},update:function(){this.set(this.manager.options.touchAction)},compute:function(){var a=[];return g(this.manager.recognizers,function(b){k(b.options.enable,[b])&&(a=a.concat(b.getTouchAction()))}),W(a.join(" "))},preventDefaults:function(a){var b=a.srcEvent,c=a.offsetDirection;if(this.manager.session.prevented)return void b.preventDefault();var d=this.actions,e=p(d,jb)&&!mb[jb],f=p(d,lb)&&!mb[lb],g=p(d,kb)&&!mb[kb];if(e){var h=1===a.pointers.length,i=a.distance<2,j=a.deltaTime<250;if(h&&i&&j)return}return g&&f?void 0:e||f&&c&Na||g&&c&Oa?this.preventSrc(b):void 0},preventSrc:function(a){this.manager.session.prevented=!0,a.preventDefault()}};var nb=1,ob=2,pb=4,qb=8,rb=qb,sb=16,tb=32;Y.prototype={defaults:{},set:function(a){return la(this.options,a),this.manager&&this.manager.touchAction.update(),this},recognizeWith:function(a){if(f(a,"recognizeWith",this))return this;var b=this.simultaneous;return a=_(a,this),b[a.id]||(b[a.id]=a,a.recognizeWith(this)),this},dropRecognizeWith:function(a){return f(a,"dropRecognizeWith",this)?this:(a=_(a,this),delete this.simultaneous[a.id],this)},requireFailure:function(a){if(f(a,"requireFailure",this))return this;var b=this.requireFail;return a=_(a,this),-1===r(b,a)&&(b.push(a),a.requireFailure(this)),this},dropRequireFailure:function(a){if(f(a,"dropRequireFailure",this))return this;a=_(a,this);var b=r(this.requireFail,a);return b>-1&&this.requireFail.splice(b,1),this},hasRequireFailures:function(){return this.requireFail.length>0},canRecognizeWith:function(a){return!!this.simultaneous[a.id]},emit:function(a){function b(b){c.manager.emit(b,a)}var c=this,d=this.state;qb>d&&b(c.options.event+Z(d)),b(c.options.event),a.additionalEvent&&b(a.additionalEvent),d>=qb&&b(c.options.event+Z(d))},tryEmit:function(a){return this.canEmit()?this.emit(a):void(this.state=tb)},canEmit:function(){for(var a=0;a<this.requireFail.length;){if(!(this.requireFail[a].state&(tb|nb)))return!1;a++}return!0},recognize:function(a){var b=la({},a);return k(this.options.enable,[this,b])?(this.state&(rb|sb|tb)&&(this.state=nb),this.state=this.process(b),void(this.state&(ob|pb|qb|sb)&&this.tryEmit(b))):(this.reset(),void(this.state=tb))},process:function(a){},getTouchAction:function(){},reset:function(){}},i(aa,Y,{defaults:{pointers:1},attrTest:function(a){var b=this.options.pointers;return 0===b||a.pointers.length===b},process:function(a){var b=this.state,c=a.eventType,d=b&(ob|pb),e=this.attrTest(a);return d&&(c&Ha||!e)?b|sb:d||e?c&Ga?b|qb:b&ob?b|pb:ob:tb}}),i(ba,aa,{defaults:{event:"pan",threshold:10,pointers:1,direction:Pa},getTouchAction:function(){var a=this.options.direction,b=[];return a&Na&&b.push(lb),a&Oa&&b.push(kb),b},directionTest:function(a){var b=this.options,c=!0,d=a.distance,e=a.direction,f=a.deltaX,g=a.deltaY;return e&b.direction||(b.direction&Na?(e=0===f?Ia:0>f?Ja:Ka,c=f!=this.pX,d=Math.abs(a.deltaX)):(e=0===g?Ia:0>g?La:Ma,c=g!=this.pY,d=Math.abs(a.deltaY))),a.direction=e,c&&d>b.threshold&&e&b.direction},attrTest:function(a){return aa.prototype.attrTest.call(this,a)&&(this.state&ob||!(this.state&ob)&&this.directionTest(a))},emit:function(a){this.pX=a.deltaX,this.pY=a.deltaY;var b=$(a.direction);b&&(a.additionalEvent=this.options.event+b),this._super.emit.call(this,a)}}),i(ca,aa,{defaults:{event:"pinch",threshold:0,pointers:2},getTouchAction:function(){return[jb]},attrTest:function(a){return this._super.attrTest.call(this,a)&&(Math.abs(a.scale-1)>this.options.threshold||this.state&ob)},emit:function(a){if(1!==a.scale){var b=a.scale<1?"in":"out";a.additionalEvent=this.options.event+b}this._super.emit.call(this,a)}}),i(da,Y,{defaults:{event:"press",pointers:1,time:251,threshold:9},getTouchAction:function(){return[hb]},process:function(a){var b=this.options,c=a.pointers.length===b.pointers,d=a.distance<b.threshold,f=a.deltaTime>b.time;if(this._input=a,!d||!c||a.eventType&(Ga|Ha)&&!f)this.reset();else if(a.eventType&Ea)this.reset(),this._timer=e(function(){this.state=rb,this.tryEmit()},b.time,this);else if(a.eventType&Ga)return rb;return tb},reset:function(){clearTimeout(this._timer)},emit:function(a){this.state===rb&&(a&&a.eventType&Ga?this.manager.emit(this.options.event+"up",a):(this._input.timeStamp=ra(),this.manager.emit(this.options.event,this._input)))}}),i(ea,aa,{defaults:{event:"rotate",threshold:0,pointers:2},getTouchAction:function(){return[jb]},attrTest:function(a){return this._super.attrTest.call(this,a)&&(Math.abs(a.rotation)>this.options.threshold||this.state&ob)}}),i(fa,aa,{defaults:{event:"swipe",threshold:10,velocity:.3,direction:Na|Oa,pointers:1},getTouchAction:function(){return ba.prototype.getTouchAction.call(this)},attrTest:function(a){var b,c=this.options.direction;return c&(Na|Oa)?b=a.overallVelocity:c&Na?b=a.overallVelocityX:c&Oa&&(b=a.overallVelocityY),this._super.attrTest.call(this,a)&&c&a.offsetDirection&&a.distance>this.options.threshold&&a.maxPointers==this.options.pointers&&qa(b)>this.options.velocity&&a.eventType&Ga},emit:function(a){var b=$(a.offsetDirection);b&&this.manager.emit(this.options.event+b,a),this.manager.emit(this.options.event,a)}}),i(ga,Y,{defaults:{event:"tap",pointers:1,taps:1,interval:300,time:250,threshold:9,posThreshold:10},getTouchAction:function(){return[ib]},process:function(a){var b=this.options,c=a.pointers.length===b.pointers,d=a.distance<b.threshold,f=a.deltaTime<b.time;if(this.reset(),a.eventType&Ea&&0===this.count)return this.failTimeout();if(d&&f&&c){if(a.eventType!=Ga)return this.failTimeout();var g=this.pTime?a.timeStamp-this.pTime<b.interval:!0,h=!this.pCenter||H(this.pCenter,a.center)<b.posThreshold;this.pTime=a.timeStamp,this.pCenter=a.center,h&&g?this.count+=1:this.count=1,this._input=a;var i=this.count%b.taps;if(0===i)return this.hasRequireFailures()?(this._timer=e(function(){this.state=rb,this.tryEmit()},b.interval,this),ob):rb}return tb},failTimeout:function(){return this._timer=e(function(){this.state=tb},this.options.interval,this),tb},reset:function(){clearTimeout(this._timer)},emit:function(){this.state==rb&&(this._input.tapCount=this.count,this.manager.emit(this.options.event,this._input))}}),ha.VERSION="2.0.7",ha.defaults={domEvents:!1,touchAction:gb,enable:!0,inputTarget:null,inputClass:null,preset:[[ea,{enable:!1}],[ca,{enable:!1},["rotate"]],[fa,{direction:Na}],[ba,{direction:Na},["swipe"]],[ga],[ga,{event:"doubletap",taps:2},["tap"]],[da]],cssProps:{userSelect:"none",touchSelect:"none",touchCallout:"none",contentZooming:"none",userDrag:"none",tapHighlightColor:"rgba(0,0,0,0)"}};var ub=1,vb=2;ia.prototype={set:function(a){return la(this.options,a),a.touchAction&&this.touchAction.update(),a.inputTarget&&(this.input.destroy(),this.input.target=a.inputTarget,this.input.init()),this},stop:function(a){this.session.stopped=a?vb:ub},recognize:function(a){var b=this.session;if(!b.stopped){this.touchAction.preventDefaults(a);var c,d=this.recognizers,e=b.curRecognizer;(!e||e&&e.state&rb)&&(e=b.curRecognizer=null);for(var f=0;f<d.length;)c=d[f],b.stopped===vb||e&&c!=e&&!c.canRecognizeWith(e)?c.reset():c.recognize(a),!e&&c.state&(ob|pb|qb)&&(e=b.curRecognizer=c),f++}},get:function(a){if(a instanceof Y)return a;for(var b=this.recognizers,c=0;c<b.length;c++)if(b[c].options.event==a)return b[c];return null},add:function(a){if(f(a,"add",this))return this;var b=this.get(a.options.event);return b&&this.remove(b),this.recognizers.push(a),a.manager=this,this.touchAction.update(),a},remove:function(a){if(f(a,"remove",this))return this;if(a=this.get(a)){var b=this.recognizers,c=r(b,a);-1!==c&&(b.splice(c,1),this.touchAction.update())}return this},on:function(a,b){if(a!==d&&b!==d){var c=this.handlers;return g(q(a),function(a){c[a]=c[a]||[],c[a].push(b)}),this}},off:function(a,b){if(a!==d){var c=this.handlers;return g(q(a),function(a){b?c[a]&&c[a].splice(r(c[a],b),1):delete c[a]}),this}},emit:function(a,b){this.options.domEvents&&ka(a,b);var c=this.handlers[a]&&this.handlers[a].slice();if(c&&c.length){b.type=a,b.preventDefault=function(){b.srcEvent.preventDefault()};for(var d=0;d<c.length;)c[d](b),d++}},destroy:function(){this.element&&ja(this,!1),this.handlers={},this.session={},this.input.destroy(),this.element=null}},la(ha,{INPUT_START:Ea,INPUT_MOVE:Fa,INPUT_END:Ga,INPUT_CANCEL:Ha,STATE_POSSIBLE:nb,STATE_BEGAN:ob,STATE_CHANGED:pb,STATE_ENDED:qb,STATE_RECOGNIZED:rb,STATE_CANCELLED:sb,STATE_FAILED:tb,DIRECTION_NONE:Ia,DIRECTION_LEFT:Ja,DIRECTION_RIGHT:Ka,DIRECTION_UP:La,DIRECTION_DOWN:Ma,DIRECTION_HORIZONTAL:Na,DIRECTION_VERTICAL:Oa,DIRECTION_ALL:Pa,Manager:ia,Input:x,TouchAction:V,TouchInput:P,MouseInput:L,PointerEventInput:M,TouchMouseInput:R,SingleTouchInput:N,Recognizer:Y,AttrRecognizer:aa,Tap:ga,Pan:ba,Swipe:fa,Pinch:ca,Rotate:ea,Press:da,on:m,off:n,each:g,merge:ta,extend:sa,assign:la,inherit:i,bindFn:j,prefixed:u});var wb="undefined"!=typeof a?a:"undefined"!=typeof self?self:{};wb.Hammer=ha, true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return ha}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!=typeof module&&module.exports?module.exports=ha:a[c]=ha}(window,document,"Hammer");
	//# sourceMappingURL=hammer.min.js.map

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	var Module_Confirm = (function (_Abstract2) {
	  _inherits(Module_Confirm, _Abstract2);
	
	  function Module_Confirm(el, options) {
	    _classCallCheck(this, Module_Confirm);
	
	    _get(Object.getPrototypeOf(Module_Confirm.prototype), "constructor", this).call(this, el, $.extend(true, {}, options), 'module');
	    this.initModule();
	  }
	
	  _createClass(Module_Confirm, [{
	    key: "initModule",
	    value: function initModule() {
	      this.initListeners();
	    }
	  }, {
	    key: "initListeners",
	    value: function initListeners() {
	      var bForcedEvent = false;
	      var $clickedElement = null;
	
	      var instanceContext = this;
	
	      //--Cancel Button Clicked
	
	      function onCancelPopup() {
	        $(".m-confirm").hide();
	        $(".m-confirm .cancel-btn, .m-confirm .m-confirm__underlay").off("click", onCancelPopup);
	        $(".m-confirm .accept-btn").off("click", onAcceptPopup);
	      }
	
	      function onAcceptPopup() {
	        $(".m-confirm").hide();
	        bForcedEvent = true;
	        $clickedElement.click();
	      }
	
	      //--Element bound with alert Clicked
	      this.$el.click(function (e) {
	        if (typeof instanceContext.options.ignore !== "undefined") {
	          switch (instanceContext.options.ignore.toLowerCase()) {
	            case "1":
	            case "true":
	              {
	                //Ignoring this if ignore setting is set to 1
	                //Use an ignore setting, as its easier to switch one value to 1 and 0 then to take away all of the components
	                return;
	                break;
	              }
	          }
	        }
	
	        if (bForcedEvent) {
	          bForcedEvent = false;
	          return;
	        }
	
	        $(".m-confirm__text").html(instanceContext.options.text);
	
	        if (typeof e !== "undefined" && e) {
	          $clickedElement = e.originalEvent.target;
	          e.preventDefault();
	        }
	
	        $(".m-confirm").show();
	        $(".m-confirm .cancel-btn, .m-confirm .m-confirm__underlay").on("click", onCancelPopup);
	        $(".m-confirm .accept-btn").on("click", onAcceptPopup);
	      });
	    }
	  }]);
	
	  return Module_Confirm;
	})(_systemAbstract2["default"]);
	
	exports["default"] = Module_Confirm;
	module.exports = exports["default"];

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	var _componentsInputValidator = __webpack_require__(10);
	
	var _componentsInputValidator2 = _interopRequireDefault(_componentsInputValidator);
	
	var Module_ContactForm = (function (_Abstract2) {
	  _inherits(Module_ContactForm, _Abstract2);
	
	  function Module_ContactForm(el, options) {
	    _classCallCheck(this, Module_ContactForm);
	
	    _get(Object.getPrototypeOf(Module_ContactForm.prototype), "constructor", this).call(this, el, $.extend(true, {}, options), 'module');
	
	    var $ctaInputForm = this.$el.find(".cta-input-form");
	    if ($ctaInputForm.length) {
	      new _componentsInputValidator2["default"]($ctaInputForm[0], { "submit_button_selector": ".cta-input-form--send-btn" });
	    }
	
	    this.initialise();
	  }
	
	  _createClass(Module_ContactForm, [{
	    key: "initialise",
	    value: function initialise() {
	      this.$el.find("[data-responsive-image]").addClass("-no-colour-loading-bg");
	
	      console.log("Contact Form Initialise");
	      this.initListeners();
	    }
	  }, {
	    key: "initListeners",
	    value: function initListeners() {
	      var _this = this;
	
	      $(".cta-options-page--tick-list-next-btn-ctn .custom-tick-list").on("click", "li", function (e) {
	        return _this.onCustomTickListItemClicked(e);
	      });
	      $(".cta-input-form--send-btn").click(function (e) {
	        return _this.onSendFormButtonClicked(e);
	      });
	    }
	  }, {
	    key: "onCustomTickListItemClicked",
	    value: function onCustomTickListItemClicked(_event) {
	      // var bOneAtATime = $(_event.currentTarget).closest(".custom-tick-list.-one-at-a-time").length >= 0;
	      var $li = $(_event.currentTarget);
	      // if(bOneAtATime)
	      // {
	      //Since we're now only triggering one at a time, lets remove the ticked modifier class on all of the li elements
	      $(".cta-options-page--tick-list-next-btn-ctn .custom-tick-list li").removeClass("-ticked");
	      // }
	
	      if ($li.hasClass("-ticked")) {
	        $li.removeClass("-ticked");
	      } else {
	        $li.addClass("-ticked");
	      }
	
	      var bAtleastOneIsTicked = $(".cta-options-page--tick-list-next-btn-ctn .custom-tick-list > li.-ticked").length > 0;
	      if (bAtleastOneIsTicked) {
	        $(".cta-options-page .cta-page--next-page-btn").removeClass("-hide");
	      } else {
	        $(".cta-options-page .cta-page--next-page-btn").addClass("-hide");
	      }
	
	      //Now hide / show elements that are specific to the selected element
	
	      $(".cta-input-form--inputs-ctn > .c-label-input-ctn").removeClass("-hide");
	
	      if ($li.hasClass("-send-email")) {
	        //dont hide anything
	
	        $(".thanks-page .cta-page--hero-text").html("Great to hear from you.<br class='-desktop-only' /> We’ll be in touch shortly.");
	      } else if ($li.hasClass("-sign-up-for-email")) {
	
	        $(".thanks-page .cta-page--hero-text").html("Thanks for signing up to<br class='-desktop-only' /> our e-newsletter.<br /><br class='-desktop-only' />We’re always in the classroom learning <br />and can’t wait to share our insights with you.");
	        //Hide location and comments
	        $(".cta-input-form--inputs-ctn [name='Location'], .cta-input-form--inputs-ctn [name='Comments']").each(function () {
	
	          var $this = $(this);
	
	          $this.closest(".c-label-input-ctn").addClass("-hide");
	        });
	      }
	    }
	  }, {
	    key: "onSendFormButtonClicked",
	    value: function onSendFormButtonClicked() {
	      var _this2 = this;
	
	      // data-component="click-behaviour"
	      //data-component-options='{"type":"hide-element-show-element","hide_target":".cta-input-form","show_target":".thanks-page"}'
	
	      console.log("onSendFormButtonClicked");
	      var tickedOptions = this.getOptionsPageValues();
	      var formData = { "HelpOption": tickedOptions };
	
	      var htmlLoader = "<div class='-loading -loader-wrapper'><div class='uil-spin-css'><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div></div></div>";
	      $(".cta-input-form--send-btn").after(htmlLoader);
	
	      //Popuplate the 'form data' we're sending off with the inputs / textareas
	      $(".cta-input-form--inputs-ctn .c-label-input-ctn:not(.-hide) .c-label-input-ctn__input-wrapper > input").each(function () {
	        formData[$(this).attr("name")] = $(this).val();
	      });
	
	      $(".cta-input-form--inputs-ctn .c-label-input-ctn:not(.-hide) .c-label-input-ctn__textarea-wrapper > textarea").each(function () {
	        formData[$(this).attr("name")] = $(this).val();
	      });
	
	      var contactID = this.$el.find("input[name='ContactID']").val();
	      if (!contactID) {
	        alert("Error: No Contact ID Found");
	        return;
	      }
	
	      formData["Contact"] = contactID;
	
	      console.log(formData);
	      var postURL = $(".m-contact-cta").data("send-to-url");
	      if (!postURL) {
	        alert("Error: No URL to send form data to");
	        return;
	      }
	
	      if (window.location.hostname === "furnware-static.uniondigital.co.nz" || window.location.hostname === "localhost") {
	        this.onFormResponse();
	        return;
	      }
	
	      formData = JSON.stringify(formData);
	      $.ajax({
	        type: "POST",
	        url: postURL,
	        dataType: 'json',
	        headers: {
	          "Authorization": "Basic cmVzdGFwaTpZcFhCSXlCRGJuTzBrNllwUnJJaQ=="
	        },
	        data: formData,
	        error: function error(e) {
	          return _this2.onFormErrorOccurred(e);
	        },
	        success: function success(e) {
	          return _this2.onFormResponse(e);
	        }
	      });
	
	      // if(postURL.indexOf("contact-response.json") !== -1)
	      // {
	      //   $.get(postURL,formData,(e)=>this.onFormResponse(e));
	      // }
	      // else
	      // {
	      //   $.post(postURL,formData,(e)=>this.onFormResponse(e));
	      // }
	    }
	  }, {
	    key: "onFormErrorOccurred",
	    value: function onFormErrorOccurred(e) {
	      alert("An error occurred submitting the form, please try again");
	    }
	  }, {
	    key: "onFormResponse",
	    value: function onFormResponse(e) {
	      $(".cta-input-form").addClass("-hide");
	      $(".thanks-page").removeClass("-hide");
	      $("body").trigger("responsive-image-check", {});
	
	      var currentScrollTop = $(window).scrollTop();
	      var offsetTopY = $(".thanks-page").offset().top;
	      $("window,body").stop().animate({ scrollTop: offsetTopY });
	    }
	  }, {
	    key: "getOptionsPageValues",
	    value: function getOptionsPageValues() {
	      var tickListOptions = "";
	
	      $(".cta-options-page--tick-list-next-btn-ctn li.-ticked").each(function () {
	        if (tickListOptions !== "") {
	          tickListOptions += ";";
	        }
	
	        tickListOptions += $(this).find("input[type='hidden']").attr("value");
	      });
	
	      return tickListOptions;
	    }
	  }]);
	
	  return Module_ContactForm;
	})(_systemAbstract2["default"]);
	
	exports["default"] = Module_ContactForm;
	module.exports = exports["default"];

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	var Component_InputValidator = (function (_Abstract2) {
	  _inherits(Component_InputValidator, _Abstract2);
	
	  function Component_InputValidator(el, options) {
	    _classCallCheck(this, Component_InputValidator);
	
	    _get(Object.getPrototypeOf(Component_InputValidator.prototype), "constructor", this).call(this, el, $.extend(true, {}, options), 'component');
	    console.log("INPUT VALIDATOR");
	    this.EMAIL_REGULAR_EXPRESSION = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	
	    this.bindEvents();
	  }
	
	  _createClass(Component_InputValidator, [{
	    key: "bindEvents",
	    value: function bindEvents() {
	      var _this = this;
	
	      this.$el.find("input").blur(function (e) {
	        return _this.onInputBlurred(e);
	      });
	      this.$el.find("input").keyup(function (e) {
	        return _this.onInputKeyUp(e);
	      });
	      // this.$el.find(" input").keydown((e) => this.onInputKeyDown(e));
	
	      if (typeof this.options.submit_button_selector !== "undefined") {
	        this.$el.find(this.options.submit_button_selector).click(function (e) {
	          return _this.onSubmitButtonClicked(e);
	        });
	      }
	    }
	  }, {
	    key: "onInputBlurred",
	    value: function onInputBlurred(e) {
	      var $input = $(e.currentTarget);
	      this.validateElement($input);
	    }
	  }, {
	    key: "onInputKeyDown",
	    value: function onInputKeyDown(e) {
	      var $input = $(e.currentTarget);
	      return this.forceCharacterLimits($input);
	    }
	  }, {
	    key: "onInputKeyUp",
	    value: function onInputKeyUp(e) {
	      var $input = $(e.currentTarget);
	      this.validateElement($input);
	    }
	  }, {
	    key: "forceCharacterLimits",
	    value: function forceCharacterLimits($element) {
	      var characterLimit = $element.data("character-limit");
	      if (!characterLimit) {
	        return true;
	      }
	
	      var elementValue = $element.val();
	      if (elementValue.length > characterLimit) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: "validateElement",
	    value: function validateElement($element) {
	
	      if (!$element.closest(".c-label-input-ctn").hasClass("required")) {
	        return;
	      }
	
	      var inputType = $element.attr("type");
	      var bValidInput = $element.val();
	      if (inputType.toLowerCase() === "email") {
	        bValidInput = this.EMAIL_REGULAR_EXPRESSION.test($element.val());
	      }
	
	      if ($element.data("match")) {
	        var matchSelector = $element.data("match");
	        var $elementToMatch = $(matchSelector);
	        if ($elementToMatch.length) {
	          if ($element.val() !== $elementToMatch.val()) {
	            bValidInput = false;
	          }
	        } else {
	          console.log("input-validator: Failed to find matching element to compare data!");
	        }
	      }
	
	      if (bValidInput) {
	        $element.removeClass("invalid-input");
	        $element.closest(".c-label-input-ctn").removeClass("invalid-input");
	        return true;
	      } else {
	        $element.addClass("invalid-input");
	        $element.closest(".c-label-input-ctn").addClass("invalid-input");
	        return false;
	      }
	    }
	  }, {
	    key: "onSubmitButtonClicked",
	    value: function onSubmitButtonClicked(e) {
	      var context = this;
	      var bAllValidated = true;
	      this.$el.find(".required input").each(function () {
	        var $input = $(this);
	        if (!context.validateElement($input)) {
	          bAllValidated = false;
	        }
	      });
	
	      if (bAllValidated) {
	        this.$el.find(".form-is-valid").removeClass('-hide');
	        this.$el.find(".form-is-invalid").addClass('-hide');
	      } else {
	        this.$el.find(".form-is-valid").addClass('-hide');
	        this.$el.find(".form-is-invalid").removeClass('-hide');
	        e.preventDefault();
	        e.stopImmediatePropagation();
	      }
	    }
	  }]);
	
	  return Component_InputValidator;
	})(_systemAbstract2["default"]);
	
	exports["default"] = Component_InputValidator;
	module.exports = exports["default"];

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	var _modulesContactForm = __webpack_require__(9);
	
	var _modulesContactForm2 = _interopRequireDefault(_modulesContactForm);
	
	var Module_ContactFormBE = (function (_Module_ContactForm) {
	  _inherits(Module_ContactFormBE, _Module_ContactForm);
	
	  function Module_ContactFormBE(el, options) {
	    _classCallCheck(this, Module_ContactFormBE);
	
	    _get(Object.getPrototypeOf(Module_ContactFormBE.prototype), "constructor", this).call(this, el, $.extend(true, {}, options), 'module');
	
	    // var $ctaInputForm = this.$el.find(".cta-input-form");
	    // if($ctaInputForm.length)
	    // {
	    //   new InputValidator($ctaInputForm[0], {"submit_button_selector":".cta-input-form--send-btn"});
	    // }
	
	    // this.initialise();
	    console.log("contact form BE");
	    this.clearInputFormFields();
	  }
	
	  //   initialise()
	  //   {
	  //     this.$el.find("[data-responsive-image]").addClass("-no-colour-loading-bg")
	
	  //     console.log("Contact Form Initialise");
	  //    this.initListeners();
	  //   }
	
	  //   initListeners()
	  //   {
	  //     $(".cta-options-page--tick-list-next-btn-ctn .custom-tick-list").on("click","li", (e) => this.onCustomTickListItemClicked(e));
	  //     $(".cta-input-form--send-btn").click((e) => this.onSendFormButtonClicked(e));
	  //   }
	
	  _createClass(Module_ContactFormBE, [{
	    key: "onCustomTickListItemClicked",
	    value: function onCustomTickListItemClicked(_event) {
	
	      console.log("tick");
	      // var bOneAtATime = $(_event.currentTarget).closest(".custom-tick-list.-one-at-a-time").length >= 0;
	      var $li = $(_event.currentTarget);
	      // if(bOneAtATime)
	      // {
	      //Since we're now only triggering one at a time, lets remove the ticked modifier class on all of the li elements
	      $(".cta-options-page--tick-list-next-btn-ctn .custom-tick-list li").removeClass("-ticked");
	      // }
	
	      var nextStepUrl = $li.attr('data-next-url');
	
	      var $nextBtn = this.$el.find('.cta-page--next-page-btn');
	
	      if ($li.hasClass("-ticked")) {
	        $li.removeClass("-ticked");
	      } else {
	        $li.addClass("-ticked");
	      }
	
	      var bAtleastOneIsTicked = $(".cta-options-page--tick-list-next-btn-ctn .custom-tick-list > li.-ticked").length > 0;
	      if (bAtleastOneIsTicked) {
	        $(".cta-options-page .cta-page--next-page-btn").removeClass("-hide");
	      } else {
	        $(".cta-options-page .cta-page--next-page-btn").addClass("-hide");
	      }
	
	      $nextBtn.attr('href', nextStepUrl);
	    }
	  }, {
	    key: "onSendFormButtonClicked",
	    value: function onSendFormButtonClicked() {
	      var _this = this;
	
	      // data-component="click-behaviour"
	      //data-component-options='{"type":"hide-element-show-element","hide_target":".cta-input-form","show_target":".thanks-page"}'
	
	      console.log("onSendFormButtonClicked");
	      var tickedOptions = this.getOptionsPageValues();
	
	      console.log("ticked option :> " + tickedOptions);
	
	      var formData = { "HelpOption": tickedOptions };
	
	      //Popuplate the 'form data' we're sending off with the inputs / textareas
	      $(".cta-input-form--inputs-ctn .c-label-input-ctn:not(.-hide) .c-label-input-ctn__input-wrapper > input").each(function () {
	        formData[$(this).attr("name")] = $(this).val();
	      });
	
	      $(".cta-input-form--inputs-ctn .c-label-input-ctn:not(.-hide) .c-label-input-ctn__textarea-wrapper > textarea").each(function () {
	        formData[$(this).attr("name")] = $(this).val();
	      });
	
	      var htmlLoader = "<div class='-loading -loader-wrapper'><div class='uil-spin-css'><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div></div></div>";
	      $(".cta-input-form--send-btn").after(htmlLoader);
	      $(".cta-input-form--send-btn").css('visibility', 'hidden');
	
	      var contactID = this.$el.find("input[name='ContactID']").val();
	      if (!contactID) {
	        alert("Error: No Contact ID Found");
	        return;
	      }
	
	      formData["Contact"] = contactID;
	      formData["SignMeUpForSomeRegularInspiration"] = false;
	      var $signMeUpCheckbox = this.$el.find("#SignMeUpForSomeRegularInspiration");
	      if ($signMeUpCheckbox.length) {
	        var signMeUpChecked = $signMeUpCheckbox.is(':checked');
	        formData["SignMeUpForSomeRegularInspiration"] = signMeUpChecked;
	      }
	
	      var postURL = $(".m-contact-cta").data("send-to-url");
	      if (!postURL) {
	        alert("Error: No URL to send form data to");
	        return;
	      }
	
	      if (window.location.hostname === "furnware-static.uniondigital.co.nz" || window.location.hostname === "localhost") {
	        this.onFormResponse();
	        return;
	      }
	
	      formData = JSON.stringify(formData);
	
	      $.ajax({
	        type: "POST",
	        url: postURL,
	        dataType: 'json',
	        headers: {
	          "Authorization": "Basic cmVzdGFwaTpZcFhCSXlCRGJuTzBrNllwUnJJaQ=="
	        },
	        data: formData,
	        error: function error(e) {
	          return _this.onFormErrorOccurred(e);
	        },
	        success: function success(e) {
	          return _this.onFormResponse(e);
	        }
	      });
	    }
	  }, {
	    key: "onFormErrorOccurred",
	    value: function onFormErrorOccurred(e) {
	      alert("An error occurred submitting the form, please try again");
	      this.$el.find(".-loader-wrapper").remove();
	      $(".cta-input-form--send-btn").css('visibility', 'visible');
	    }
	  }, {
	    key: "onFormResponse",
	    value: function onFormResponse(e) {
	      // $(".cta-input-form").addClass("-hide");
	      // $(".thanks-page").removeClass("-hide");
	      // $("body").trigger("responsive-image-check",{});
	
	      // var currentScrollTop = $(window).scrollTop();
	      // var offsetTopY = $(".thanks-page").offset().top;
	      // $("window,body").stop().animate({scrollTop:offsetTopY});
	
	      window.location.href = this.options.thankYouLocation;
	
	      //console.log('success');
	    }
	  }, {
	    key: "showThankYouMessage",
	    value: function showThankYouMessage(tickedOption) {
	
	      if (tickedOption == 1) {
	        console.log("ticked option :> " + tickedOption);
	
	        $(".thanks-page .cta-page--hero-text").html("Great to hear from you.<br class='-desktop-only' /> We’ll be in touch shortly.");
	      }
	
	      if (tickedOption == 2) {
	        console.log("ticked option :> " + tickedOption);
	
	        $(".thanks-page .cta-page--hero-text").html("Thanks for signing up to<br class='-desktop-only' /> our e-newsletter.<br /><br class='-desktop-only' />We’re always in the classroom learning <br />and can’t wait to share our insights with you.");
	      }
	    }
	  }, {
	    key: "getOptionsPageValues",
	    value: function getOptionsPageValues() {
	      var tickListOptions = "";
	
	      this.$el.find(".js-form-stream-val").each(function () {
	        if (tickListOptions !== "") {
	          tickListOptions += ";";
	        }
	
	        tickListOptions += $(this).attr("value");
	      });
	
	      return tickListOptions;
	    }
	  }, {
	    key: "clearInputFormFields",
	    value: function clearInputFormFields() {
	      $('.js-clear-btn').click(function () {
	        $('.c-label-input__fields').val('');
	        $('#SignMeUpForSomeRegularInspiration').prop("checked", false);
	      });
	    }
	  }]);
	
	  return Module_ContactFormBE;
	})(_modulesContactForm2["default"]);
	
	exports["default"] = Module_ContactFormBE;
	module.exports = exports["default"];

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	var _modulesContactFormV2 = __webpack_require__(13);
	
	var _modulesContactFormV22 = _interopRequireDefault(_modulesContactFormV2);
	
	var Module_ContactFormBEv2 = (function (_Module_ContactForm) {
	  _inherits(Module_ContactFormBEv2, _Module_ContactForm);
	
	  function Module_ContactFormBEv2(el, options) {
	    _classCallCheck(this, Module_ContactFormBEv2);
	
	    _get(Object.getPrototypeOf(Module_ContactFormBEv2.prototype), "constructor", this).call(this, el, $.extend(true, {}, options), 'module');
	
	    // var $ctaInputForm = this.$el.find(".cta-input-form");
	    // if($ctaInputForm.length)
	    // {
	    //   new InputValidator($ctaInputForm[0], {"submit_button_selector":".cta-input-form--send-btn"});
	    // }
	
	    // this.initialise();
	    this.clearInputFormFields();
	    var userFormTemplate = document.getElementById("aspnetForm");
	  }
	
	  //   initialise()
	  //   {
	  //     this.$el.find("[data-responsive-image]").addClass("-no-colour-loading-bg")
	
	  //     console.log("Contact Form Initialise");
	  //    this.initListeners();
	  //   }
	
	  //   initListeners()
	  //   {
	  //     $(".cta-options-page--tick-list-next-btn-ctn .custom-tick-list").on("click","li", (e) => this.onCustomTickListItemClicked(e));
	  //     $(".cta-input-form--send-btn").click((e) => this.onSendFormButtonClicked(e));
	  //   }
	
	  _createClass(Module_ContactFormBEv2, [{
	    key: "onCustomTickListItemClicked",
	    value: function onCustomTickListItemClicked(_event) {
	
	      console.log("tick");
	      // var bOneAtATime = $(_event.currentTarget).closest(".custom-tick-list.-one-at-a-time").length >= 0;
	      var $li = $(_event.currentTarget);
	      // if(bOneAtATime)
	      // {
	      //Since we're now only triggering one at a time, lets remove the ticked modifier class on all of the li elements
	      $(".cta-options-page--tick-list-next-btn-ctn .custom-tick-list li").removeClass("-ticked");
	      // }
	
	      var nextStepUrl = $li.attr('data-next-url');
	
	      var $nextBtn = this.$el.find('.cta-page--next-page-btn');
	
	      if ($li.hasClass("-ticked")) {
	        $li.removeClass("-ticked");
	      } else {
	        $li.addClass("-ticked");
	      }
	
	      var bAtleastOneIsTicked = $(".cta-options-page--tick-list-next-btn-ctn .custom-tick-list > li.-ticked").length > 0;
	      if (bAtleastOneIsTicked) {
	        $(".cta-options-page .cta-page--next-page-btn").removeClass("-hide");
	      } else {
	        $(".cta-options-page .cta-page--next-page-btn").addClass("-hide");
	      }
	
	      $nextBtn.attr('href', nextStepUrl);
	    }
	  }, {
	    key: "onSendFormButtonClicked",
	    value: function onSendFormButtonClicked() {
	
	      // Change checkbox value when checked
	      var $signMeUp = $('input[name="subscribe"]');
	      if ($signMeUp.prop('checked')) {
	        $('.js-form-stream-val').attr('value', 1);
	      } else {
	        $('.js-form-stream-val').attr('value', 0);
	      }
	
	      //   if(window.innerWidth >768 ) {
	      //     var htmlLoader = "<div class='-loading -loader-wrapper'><div class='uil-spin-css'><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div></div></div>";
	      //     $(".cta-input-form--send-btn").after(htmlLoader);
	      //     $(".cta-input-form--send-btn").css('visibility', 'hidden');
	      //   } else {
	      //     var htmlLoader = "<div class='-loading -loader-wrapper -loading-inline'><div class='uil-spin-css'><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div></div></div>";
	      //     $(".cta-input-form--send-btn").after(htmlLoader);
	      //     $(".cta-input-form--send-btn").css('display', 'none');
	      //  }
	
	      var htmlLoader = "<div class='-loading -loader-wrapper'><div class='uil-spin-css'><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div></div></div>";
	      $(".cta-input-sugarform--send-btn").after(htmlLoader);
	      $(".cta-input-sugarform--send-btn").css('visibility', 'hidden');
	
	      if (window.location.hostname === "furnware-static.uniondigital.co.nz" || window.location.hostname === "localhost") {
	        // ! remove return
	        //return;
	      }
	
	      $("#aspnetForm").attr('action', $(".cta-input-form").data("sugar-market-post-url"));
	
	      $("#aspnetForm").unbind('submit').removeAttr('onsubmit');
	
	      $("#aspnetForm").submit();
	    }
	  }, {
	    key: "onFormErrorOccurred",
	    value: function onFormErrorOccurred(e) {
	      alert("An error occurred submitting the form, please try again");
	      this.$el.find(".-loader-wrapper").remove();
	      $(".cta-input-sugarform--send-btn").css('visibility', 'visible');
	    }
	  }, {
	    key: "clearInputFormFields",
	    value: function clearInputFormFields() {
	      $('.js-clear-btn').click(function () {
	        $('.c-label-input__fields').val('');
	        $('.c-label-select__fields').prop('selectedIndex', 0).selectric('refresh');
	        $('#donotbulkemail0').prop("checked", false);
	        $('#SignMeUpForSomeRegularInspiration').prop("checked", false);
	      });
	    }
	  }]);
	
	  return Module_ContactFormBEv2;
	})(_modulesContactFormV22["default"]);
	
	exports["default"] = Module_ContactFormBEv2;
	module.exports = exports["default"];

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	var _componentsInputValidatorV2 = __webpack_require__(14);
	
	var _componentsInputValidatorV22 = _interopRequireDefault(_componentsInputValidatorV2);
	
	var Module_ContactForm = (function (_Abstract2) {
	  _inherits(Module_ContactForm, _Abstract2);
	
	  function Module_ContactForm(el, options) {
	    _classCallCheck(this, Module_ContactForm);
	
	    _get(Object.getPrototypeOf(Module_ContactForm.prototype), "constructor", this).call(this, el, $.extend(true, {}, options), 'module');
	
	    var $ctaInputForm = this.$el.find(".cta-input-form");
	    if ($ctaInputForm.length) {
	      new _componentsInputValidatorV22["default"]($ctaInputForm[0], { "submit_button_selector": ".cta-input-sugarform--send-btn" });
	    }
	
	    this.initialise();
	  }
	
	  _createClass(Module_ContactForm, [{
	    key: "initialise",
	    value: function initialise() {
	      this.$el.find("[data-responsive-image]").addClass("-no-colour-loading-bg");
	      this.initListeners();
	    }
	  }, {
	    key: "initListeners",
	    value: function initListeners() {
	      var _this = this;
	
	      $(".cta-options-page--tick-list-next-btn-ctn .custom-tick-list").on("click", "li", function (e) {
	        return _this.onCustomTickListItemClicked(e);
	      });
	      $(".cta-input-sugarform--send-btn").click(function (e) {
	        return _this.onSendFormButtonClicked(e);
	      });
	    }
	  }, {
	    key: "onCustomTickListItemClicked",
	    value: function onCustomTickListItemClicked(_event) {
	      // var bOneAtATime = $(_event.currentTarget).closest(".custom-tick-list.-one-at-a-time").length >= 0;
	      var $li = $(_event.currentTarget);
	      // if(bOneAtATime)
	      // {
	      //Since we're now only triggering one at a time, lets remove the ticked modifier class on all of the li elements
	      $(".cta-options-page--tick-list-next-btn-ctn .custom-tick-list li").removeClass("-ticked");
	      // }
	
	      if ($li.hasClass("-ticked")) {
	        $li.removeClass("-ticked");
	      } else {
	        $li.addClass("-ticked");
	      }
	
	      var bAtleastOneIsTicked = $(".cta-options-page--tick-list-next-btn-ctn .custom-tick-list > li.-ticked").length > 0;
	      if (bAtleastOneIsTicked) {
	        $(".cta-options-page .cta-page--next-page-btn").removeClass("-hide");
	      } else {
	        $(".cta-options-page .cta-page--next-page-btn").addClass("-hide");
	      }
	
	      //Now hide / show elements that are specific to the selected element
	
	      $(".cta-input-form--inputs-ctn > .c-label-input-ctn").removeClass("-hide");
	
	      if ($li.hasClass("-send-email")) {
	        //dont hide anything
	
	        $(".thanks-page .cta-page--hero-text").html("Great to hear from you.<br class='-desktop-only' /> We’ll be in touch shortly.");
	      } else if ($li.hasClass("-sign-up-for-email")) {
	
	        $(".thanks-page .cta-page--hero-text").html("Thanks for signing up to<br class='-desktop-only' /> our e-newsletter.<br /><br class='-desktop-only' />We’re always in the classroom learning <br />and can’t wait to share our insights with you.");
	        //Hide location and comments
	        $(".cta-input-form--inputs-ctn [name='Location'], .cta-input-form--inputs-ctn [name='Comments']").each(function () {
	
	          var $this = $(this);
	
	          $this.closest(".c-label-input-ctn").addClass("-hide");
	        });
	      }
	    }
	  }, {
	    key: "onSendFormButtonClicked",
	    value: function onSendFormButtonClicked() {
	      // data-component="click-behaviour"
	      //data-component-options='{"type":"hide-element-show-element","hide_target":".cta-input-form","show_target":".thanks-page"}'
	
	      console.log('FROM - Contactform-v2 onSubmitButtonClicked');
	      var tickedOptions = this.getOptionsPageValues();
	      var formData = { "HelpOption": tickedOptions };
	
	      var htmlLoader = "<div class='-loading -loader-wrapper'><div class='uil-spin-css'><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div></div></div>";
	      $(".cta-input-sugarform--send-btn").after(htmlLoader);
	
	      //Popuplate the 'form data' we're sending off with the inputs / textareas
	      $(".cta-input-form--inputs-ctn .c-label-input-ctn:not(.-hide) .c-label-input-ctn__input-wrapper > input").each(function () {
	        formData[$(this).attr("name")] = $(this).val();
	      });
	
	      $(".cta-input-form--inputs-ctn .c-label-input-ctn:not(.-hide) .c-label-input-ctn__textarea-wrapper > textarea").each(function () {
	        formData[$(this).attr("name")] = $(this).val();
	      });
	
	      var contactID = this.$el.find("input[name='ContactID']").val();
	      if (!contactID) {
	        alert("Error: No Contact ID Found");
	        return;
	      }
	
	      formData["Contact"] = contactID;
	
	      // console.log(formData);
	      // var postURL = $(".m-contact-cta").data("send-to-url");
	      // if(!postURL)
	      // {
	      //   alert("Error: No URL to send form data to");
	      //   return;
	      // }
	
	      if (window.location.hostname === "furnware-static.uniondigital.co.nz" || window.location.hostname === "localhost") {
	        this.onFormResponse();
	        return;
	      }
	
	      // formData = JSON.stringify(formData);
	      // $.ajax
	      // ({
	      //   type: "POST",
	      //   url: postURL,
	      //   dataType: 'json',
	      //   headers: {
	      //     "Authorization": "Basic cmVzdGFwaTpZcFhCSXlCRGJuTzBrNllwUnJJaQ=="
	      //   },
	      //   data: formData,
	      //   error:(e) => this.onFormErrorOccurred(e),
	      //   success: (e) => this.onFormResponse(e)
	      // });
	
	      // if(postURL.indexOf("contact-response.json") !== -1)
	      // {
	      //   $.get(postURL,formData,(e)=>this.onFormResponse(e));
	      // }
	      // else
	      // {
	      //   $.post(postURL,formData,(e)=>this.onFormResponse(e));
	      // }
	    }
	  }, {
	    key: "onFormErrorOccurred",
	    value: function onFormErrorOccurred(e) {
	      alert("An error occurred submitting the form, please try again");
	    }
	  }, {
	    key: "onFormResponse",
	    value: function onFormResponse(e) {
	      $(".cta-input-form").addClass("-hide");
	      $(".thanks-page").removeClass("-hide");
	      $("body").trigger("responsive-image-check", {});
	
	      var currentScrollTop = $(window).scrollTop();
	      var offsetTopY = $(".thanks-page").offset().top;
	      $("window,body").stop().animate({ scrollTop: offsetTopY });
	    }
	  }, {
	    key: "getOptionsPageValues",
	    value: function getOptionsPageValues() {
	      var tickListOptions = "";
	
	      $(".cta-options-page--tick-list-next-btn-ctn li.-ticked").each(function () {
	        if (tickListOptions !== "") {
	          tickListOptions += ";";
	        }
	
	        tickListOptions += $(this).find("input[type='hidden']").attr("value");
	      });
	
	      return tickListOptions;
	    }
	  }]);
	
	  return Module_ContactForm;
	})(_systemAbstract2["default"]);
	
	exports["default"] = Module_ContactForm;
	module.exports = exports["default"];

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	var Component_InputValidatorv2 = (function (_Abstract2) {
	  _inherits(Component_InputValidatorv2, _Abstract2);
	
	  function Component_InputValidatorv2(el, options) {
	    _classCallCheck(this, Component_InputValidatorv2);
	
	    _get(Object.getPrototypeOf(Component_InputValidatorv2.prototype), "constructor", this).call(this, el, $.extend(true, {}, options), "component");
	    this.EMAIL_REGULAR_EXPRESSION = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	    this.bindEvents();
	    $("select.c-label-select__fields").selectric({
	      disableOnMobile: false,
	      nativeOnMobile: false,
	      onChange: function onChange() {
	        $(".selectric-c-label-select__fields").removeClass("is-invalid");
	      }
	    }).on("selectric-before-open", function () {
	      if ($(".selectric-c-label-select__fields").hasClass("is-invalid")) {
	        $(".selectric-c-label-select__fields").removeClass("is-invalid");
	      }
	    });
	  }
	
	  _createClass(Component_InputValidatorv2, [{
	    key: "bindEvents",
	    value: function bindEvents() {
	      var _this = this;
	
	      this.$el.find("input").blur(function (e) {
	        return _this.onInputBlurred(e);
	      });
	      this.$el.find("input").keyup(function (e) {
	        return _this.onInputKeyUp(e);
	      });
	      this.$el.find("textarea").blur(function (e) {
	        return _this.onTextareBlurred(e);
	      });
	      this.$el.find("textarea").keyup(function (e) {
	        return _this.onTextareKeyUp(e);
	      });
	      if (typeof this.options.submit_button_selector !== "undefined") {
	        this.$el.find(this.options.submit_button_selector).click(function (e) {
	          return _this.onSubmitButtonClicked(e);
	        });
	      }
	    }
	  }, {
	    key: "onInputBlurred",
	    value: function onInputBlurred(e) {
	      var $input = $(e.currentTarget);
	      this.validateElement($input);
	    }
	  }, {
	    key: "onInputKeyDown",
	    value: function onInputKeyDown(e) {
	      var $input = $(e.currentTarget);
	      return this.forceCharacterLimits($input);
	    }
	  }, {
	    key: "onInputKeyUp",
	    value: function onInputKeyUp(e) {
	      var $input = $(e.currentTarget);
	      this.validateElement($input);
	    }
	  }, {
	    key: "onTextareKeyUp",
	    value: function onTextareKeyUp(e) {
	      var $input = $(e.currentTarget);
	      this.validateElement($input);
	    }
	  }, {
	    key: "onTextareBlurred",
	    value: function onTextareBlurred(e) {
	      var $input = $(e.currentTarget);
	      this.validateElement($input);
	    }
	  }, {
	    key: "forceCharacterLimits",
	    value: function forceCharacterLimits($element) {
	      var characterLimit = $element.data("character-limit");
	      if (!characterLimit) {
	        return true;
	      }
	
	      var elementValue = $element.val();
	      if (elementValue.length > characterLimit) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: "validateTextarea",
	    value: function validateTextarea($element) {
	      if ($element.val()) {
	        $element.removeClass("invalid-input");
	        $element.closest(".c-label-input-ctn").removeClass("invalid-input");
	        return true;
	      } else {
	        $element.addClass("invalid-input");
	        $element.closest(".c-label-input-ctn").addClass("invalid-input");
	        return false;
	      }
	    }
	  }, {
	    key: "validateElement",
	    value: function validateElement($element) {
	      if (!$element.closest(".c-label-input-ctn").hasClass("required")) {
	        return;
	      }
	
	      var inputType = $element.attr("type");
	      var bValidInput = $element.val();
	      if (inputType.toLowerCase() === "email") {
	        bValidInput = this.EMAIL_REGULAR_EXPRESSION.test($element.val());
	      }
	
	      if ($element.data("match")) {
	        var matchSelector = $element.data("match");
	        var $elementToMatch = $(matchSelector);
	        if ($elementToMatch.length) {
	          if ($element.val() !== $elementToMatch.val()) {
	            bValidInput = false;
	          }
	        } else {
	          console.log("input-validator: Failed to find matching element to compare data!");
	        }
	      }
	
	      if (bValidInput) {
	        $(".-error").html("Comments Field<span>*</span>");
	        $element.removeClass("invalid-input");
	        $element.closest(".c-label-input-ctn").removeClass("invalid-input");
	        return true;
	      } else {
	        $(".-error").html("Comments<span>*</span>");
	        $element.addClass("invalid-input");
	        $element.closest(".c-label-input-ctn").addClass("invalid-input");
	        return false;
	      }
	    }
	  }, {
	    key: "onErrorScrollTop",
	    value: function onErrorScrollTop() {
	      $("html,body").animate({
	        scrollTop: $(".-scrolltop").offset().top - 30
	      }, "fast");
	    }
	  }, {
	    key: "formValidation",
	    value: function formValidation(bAllValidated, e) {
	      var context = this;
	      if (bAllValidated) {
	        context.$el.find(".form-is-valid").removeClass("-hide");
	        context.$el.find(".form-is-invalid").addClass("-hide");
	        // Change checkbox value when checked
	        var $signMeUp = $('input[name="subscribe"]');
	        if ($signMeUp.prop("checked")) {
	          $(".js-form-stream-val").attr("value", 1);
	        } else {
	          $(".js-form-stream-val").attr("value", 0);
	        }
	        var htmlLoader = "<div class='-loading -loader-wrapper'><div class='uil-spin-css'><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div></div></div>";
	        $(".cta-input-sugarform--send-btn").after(htmlLoader);
	        $(".cta-input-sugarform--send-btn").css("visibility", "hidden");
	
	        if (window.location.hostname === "furnware-static.uniondigital.co.nz" || window.location.hostname === "localhost") {
	          return;
	        }
	        if ($(e.currentTarget).hasClass("stem-submit-btn")) {
	          context.setCookie("stemlearningpopup", "clicked", 100000);
	        }
	        $("#aspnetForm").attr("action", $(".cta-input-form").data("sugar-market-post-url"));
	        $("#aspnetForm").unbind("submit").removeAttr("onsubmit");
	        $("#aspnetForm").submit();
	      } else {
	        context.$el.find(".form-is-valid").addClass("-hide");
	        context.$el.find(".form-is-invalid").removeClass("-hide");
	        grecaptcha.reset();
	        context.onErrorScrollTop();
	        e.preventDefault();
	        e.stopImmediatePropagation();
	      }
	    }
	  }, {
	    key: "recaptchaValidation",
	    value: function recaptchaValidation(context, bAllValidated, e) {
	      $.ajax({
	        type: "GET",
	        url: "/WebApi/ReCaptchaApi/VerifyReCaptcha?reCaptchaResponse=" + grecaptcha.getResponse(),
	        error: function error(response) {
	          bAllValidated = false;
	          $(".g-recaptcha__errormsg").addClass("-hide");
	          context.formValidation(bAllValidated, e);
	        },
	        success: function success(response) {
	          if (response == true) {
	            $(".g-recaptcha__errormsg").addClass("-hide");
	            context.formValidation(bAllValidated, e);
	          } else {
	            bAllValidated = false;
	            $(".g-recaptcha__errormsg").removeClass("-hide");
	            context.formValidation(bAllValidated, e);
	          }
	        }
	      });
	    }
	  }, {
	    key: "onSubmitButtonClicked",
	    value: function onSubmitButtonClicked(e) {
	      var context = this;
	      var bAllValidated = true;
	      var dropdownValidated = true;
	      var textareaValidated = true;
	      if ($(".cta-input-form").data("sugar-market-form") == "contact") {
	        if ($(".c-label-select__fields").val() == "-1") {
	          $(".selectric-c-label-select__fields").addClass("is-invalid");
	          dropdownValidated = false;
	        }
	        if (this.$el.find(".required textarea").length > 0) {
	          textareaValidated = this.validateTextarea(this.$el.find(".required textarea"));
	        }
	        this.$el.find(".required input").each(function () {
	          var $input = $(this);
	          if (!context.validateElement($input)) {
	            bAllValidated = false;
	          }
	        });
	        if (bAllValidated && textareaValidated && dropdownValidated) {
	          this.$el.find(".form-is-valid").removeClass("-hide");
	          this.$el.find(".form-is-invalid").addClass("-hide");
	        } else {
	          this.$el.find(".form-is-valid").addClass("-hide");
	          this.$el.find(".form-is-invalid").removeClass("-hide");
	          this.onErrorScrollTop();
	          e.preventDefault();
	          e.stopImmediatePropagation();
	        }
	        e.preventDefault();
	        e.stopImmediatePropagation();
	        context.recaptchaValidation(context, bAllValidated, e);
	      } else {
	        if ($(".c-label-select__fields").length) {
	          if ($(".c-label-select__fields").val() == "-1") {
	            $(".selectric-c-label-select__fields").addClass("is-invalid");
	            bAllValidated = false;
	          }
	        }
	        this.$el.find(".required input").each(function () {
	          var $input = $(this);
	          if (!context.validateElement($input)) {
	            bAllValidated = false;
	          }
	        });
	        e.preventDefault();
	        e.stopImmediatePropagation();
	        context.recaptchaValidation(context, bAllValidated, e);
	      }
	    }
	  }]);
	
	  return Component_InputValidatorv2;
	})(_systemAbstract2["default"]);
	
	exports["default"] = Component_InputValidatorv2;
	module.exports = exports["default"];

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	var Module_Filter = (function (_Abstract2) {
	    _inherits(Module_Filter, _Abstract2);
	
	    function Module_Filter(el, options) {
	        _classCallCheck(this, Module_Filter);
	
	        _get(Object.getPrototypeOf(Module_Filter.prototype), "constructor", this).call(this, el, $.extend(true, {}, options), 'module');
	
	        this.FADE_OUT_DURATION = 50;
	        this.FADE_IN_DURATION = 100;
	        this.m_bIsOurPeopleFilter = $(".-read-bio").length;
	
	        this.initModule();
	    }
	
	    /********* Initialising ***************/
	
	    _createClass(Module_Filter, [{
	        key: "initModule",
	        value: function initModule() {
	            this.$mList = this.$el.closest(".m-list");
	            this.$mListColumns = this.$el.closest(".m-list").find(".m-columns__columns");
	            this.$mContainerList = this.$mList.find(".m-list__list");
	            this.$elItemBtn = this.$el.find("a");
	            this.$elItemSelect = this.$el.find("select");
	            this.initListener();
	            this.triggers();
	            this.setBorders();
	        }
	    }, {
	        key: "initListener",
	        value: function initListener() {
	            var _this = this;
	
	            this.$el.on("click", "a", function (e) {
	                return _this.onItemClicked(e);
	            });
	            this.$el.on("change", "select", function (e) {
	                return _this.onSelectBoxChanged(e);
	            });
	
	            if (this.m_bIsOurPeopleFilter) {
	                $(".m-columns__column").on("click", ".-read-bio, .-read-bio-mobile, .m-list__name", function (e) {
	                    return _this.onReadBioClicked(e);
	                });
	
	                if (window.location.hash) {
	                    var hashRemoved = encodeURI(window.location.hash.replace("#", ""));
	                    var context = this;
	                    $(".m-list__item[data-name!='']").each(function () {
	                        var $this = $(this);
	                        var encodedDataName = encodeURI($this.data("name"));
	                        if (encodedDataName === hashRemoved) {
	                            context.goToListItemDetail.call(context, $this, true, false);
	                            return false;
	                        }
	                    });
	                }
	
	                //Triggers the filter to display on the first item  by default
	                this.$el.find(".-btns a.-active").click();
	            }
	            $(".-back").click(function (e) {
	                return _this.onBackButtonClicked(e);
	            });
	            this.$mList.on("click", ".m-list__item.-accordion .m-list__description, .m-list__item.-accordion .m-list__avatar, .m-list__item.-accordion .-open-accordion", function (e) {
	                return _this.onAccordianItemClicked(e);
	            });
	        }
	    }, {
	        key: "goToListItemDetail",
	        value: function goToListItemDetail(_$listItem, fadeTo, _scrollToDetail) {
	            if (!_$listItem.length) {
	                console.log("no list item found");
	                return;
	            }
	
	            // $("body").animate({scrollTop:});
	            // $("body").animate({scrollTop:$(".m-profile").offset().top});
	
	            if (typeof _scrollToDetail === "undefined") {
	                _scrollToDetail = true;
	            }
	
	            if (typeof fadeTo === "undefined") {
	                fadeTo = true;
	            }
	
	            this.copyListItemDetailsToDetailItem(_$listItem);
	
	            var context = this;
	
	            $(".m-list__list").stop(true, true);
	            if (fadeTo) {
	                this.$mContainerList.fadeOut(this.FADE_OUT_DURATION, function () {
	                    $(".m-profile").fadeIn({ duration: this.FADE_IN_DURATION });
	                    if (_scrollToDetail) {
	                        context.scrollToTopOfProfileElement(true);
	                    }
	                });
	            } else {
	                this.$mContainerList.hide();
	                $(".m-profile").show();
	                if (_scrollToDetail) {
	                    this.scrollToTopOfProfileElement(false);
	                }
	            }
	
	            this.$el.addClass('disabled');
	            this.$el.find("select").prop("disabled", true);
	            window.location.hash = _$listItem.data("name");
	        }
	    }, {
	        key: "scrollToTopOfProfileElement",
	        value: function scrollToTopOfProfileElement(_bAnimateTo) {
	            if (_bAnimateTo) {
	                $("html,body").animate({ scrollTop: $(".m-profile").offset().top });
	            } else {
	                $("html,body").scrollTop($(".m-profile").offset().top);
	            }
	        }
	    }, {
	        key: "onReadBioClicked",
	        value: function onReadBioClicked(e) {
	            e.preventDefault(); //Removing this will cause the page to jump to the top, then scroll down
	            //Also causes issues with mobile
	            var $listItem = $(e.currentTarget).closest(".m-list__item");
	            this.goToListItemDetail($listItem);
	        }
	    }, {
	        key: "copyListItemDetailsToDetailItem",
	        value: function copyListItemDetailsToDetailItem(_$item) {
	
	            var classesTextToCopy = [".m-list__name", ".m-list__about"];
	            var classesHTMLToCopy = [".m-profile__phone", ".m-profile__email"];
	
	            for (var i = classesTextToCopy.length - 1; i >= 0; i--) {
	                var selector = classesTextToCopy[i];
	                this.copySelectorTextFromListToDetail(_$item, selector);
	            }
	
	            for (var i = classesHTMLToCopy.length - 1; i >= 0; i--) {
	                var selector = classesHTMLToCopy[i];
	                this.copySelectorHTMLFromListToDetail(_$item, selector);
	            }
	
	            this.copySocialMediaOptionsFromListItemToDetail(_$item);
	            var htmlBioData = _$item.find(".m-profile__bio").html().trim();
	            var dataResponsiveImageAttr = _$item.find(".m-list__avatar").data("responsive-image");
	            var $profileAvatarElement = $(".m-profile").find(".m-profile__avatar");
	
	            $profileAvatarElement.css("background-image", "none");
	            $profileAvatarElement.data("responsive-image", dataResponsiveImageAttr);
	
	            var $profileBioElement = $(".m-profile").find(".m-profile__bio");
	            if (htmlBioData) {
	                $profileBioElement.html(htmlBioData);
	                $profileBioElement.show();
	            } else {
	                $profileBioElement.hide();
	            }
	            $("body").trigger("responsive-image", { $responsiveImageTargets: $profileAvatarElement });
	        }
	    }, {
	        key: "copySocialMediaOptionsFromListItemToDetail",
	        value: function copySocialMediaOptionsFromListItemToDetail(_$item) {
	
	            var $listItemTwitterElement = _$item.find(".-twitter");
	            var $listItemLinkedinElement = _$item.find(".-linkedin");
	
	            // var twitterOptions = $listItemTwitterElement.data("component-options");
	            // var linkedinOptions = $listItemLinkedinElement.data("component-options");
	
	            var $profileContainerElement = $(".m-profile");
	            var $profileContainerTwitterElement = $profileContainerElement.find(".-twitter");
	            var $profileContainerLinkedinElement = $profileContainerElement.find(".-linkedin");
	
	            if ($listItemTwitterElement.length) {
	
	                $profileContainerTwitterElement.prop("href", $listItemTwitterElement.prop("href"));
	                // $profileContainerTwitterElement.data("component-options",twitterOptions);
	                $profileContainerTwitterElement.show();
	            } else {
	                $profileContainerTwitterElement.hide();
	            }
	
	            if ($listItemLinkedinElement.length) {
	
	                $profileContainerLinkedinElement.prop("href", $listItemLinkedinElement.prop("href"));
	                // $profileContainerLinkedinElement.data("component-options",linkedinOptions);
	                $profileContainerLinkedinElement.show();
	            } else {
	                $profileContainerLinkedinElement.hide();
	            }
	
	            // if(!$listItemLinkedinElement.length && !$listItemTwitterElement.length)
	            // {
	            //     $(".m-profile__description .m-profile__details > a").hide();
	            // }
	            // else
	            // {
	            //     $(".m-profile__description .m-profile__details > a").show();
	            // }
	        }
	    }, {
	        key: "copySelectorTextFromListToDetail",
	        value: function copySelectorTextFromListToDetail(_$item, _$selector) {
	            var value = _$item.find(_$selector).text();
	            var profileSelector = _$selector.replace("m-list", "m-profile");
	            $(".m-profile").find(profileSelector).text(value);
	        }
	    }, {
	        key: "copySelectorHTMLFromListToDetail",
	        value: function copySelectorHTMLFromListToDetail(_$item, _$selector) {
	            var value = _$item.find(_$selector).html();
	            var profileSelector = _$selector.replace("m-list", "m-profile");
	            $(".m-profile").find(profileSelector).html(value);
	        }
	    }, {
	        key: "onBackButtonClicked",
	        value: function onBackButtonClicked(e) {
	            e.preventDefault();
	            // history.pushState(null, null, '');
	            window.location.hash = "listings";
	            // $(".m-profile").css('display','none');
	            // $(".m-list__list").css('display','block');
	
	            // window.location.origin + window.location.pathname
	
	            $(".m-profile").stop(true, true).fadeOut(this.FADE_OUT_DURATION, function () {
	                $(".m-list__list").fadeIn({ duration: this.FADE_IN_DURATION });
	            });
	
	            this.$el.removeClass('disabled');
	            this.$el.find("select").prop("disabled", false);
	        }
	    }, {
	        key: "onSelectBoxChanged",
	        value: function onSelectBoxChanged(e) {
	            this.changeStatus(e);
	        }
	    }, {
	        key: "onItemClicked",
	        value: function onItemClicked(e) {
	            this.changeStatus(e);
	        }
	    }, {
	        key: "onAccordianItemClicked",
	        value: function onAccordianItemClicked(e) {
	            console.log('click accordion');
	
	            var $parent = $(e.target).closest('.m-list__item');
	            var $accordianItems = $('.m-list__item');
	
	            if (!$parent.hasClass("-is-open")) {
	                $accordianItems.removeClass("-is-open");
	                $parent.addClass("-is-open");
	            } else {
	                $parent.removeClass("-is-open");
	            }
	        }
	    }, {
	        key: "changeStatus",
	        value: function changeStatus(e) {
	            e.preventDefault();
	            var f;
	            $(this.$el).find("a").removeClass("-active");
	
	            if ($(e.target).hasClass('c-form__select')) {
	                f = $(e.target).val();
	                $('[data-filter-option="' + f + '"]').addClass('-active');
	            } else {
	                f = $(e.target).attr('data-filter-option');
	
	                this.$elItemSelect.val(f);
	            }
	
	            if ($(this.$el).hasClass('disabled')) {
	                return;
	            }
	
	            var $this = $(this);
	
	            $(e.target).addClass('-active');
	            this.filterList(f);
	        }
	    }, {
	        key: "filterList",
	        value: function filterList(option) {
	            console.log(option);
	            if (option == "all") {
	                this.$mContainerList.find(".m-list__item").addClass('show');
	            } else {
	                this.$mContainerList.find(".m-list__item").removeClass('show');
	                $('[data-filter-item*=";' + option + ';"]').addClass('show');
	            }
	            this.setBorders();
	        }
	    }, {
	        key: "setBorders",
	        value: function setBorders() {
	
	            this.$mContainerList.find(".m-list__item.show").removeClass("-no-bottom-border");
	            this.$mContainerList.find(".m-list__item.show:last").addClass("-no-bottom-border");
	        }
	    }, {
	        key: "triggers",
	        value: function triggers() {
	
	            activateAccordion();
	            $(window).resize(function () {
	                activateAccordion();
	            });
	
	            function activateAccordion() {
	                if ($("body").hasClass("mobile")) {
	                    $('.m-list__item').addClass('-accordion');
	                } else {
	                    $('.m-list__item').removeClass('-accordion');
	                }
	            }
	        }
	    }]);
	
	    return Module_Filter;
	})(_systemAbstract2["default"]);
	
	exports["default"] = Module_Filter;
	module.exports = exports["default"];

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	var Module_Modal = (function (_Abstract2) {
	  _inherits(Module_Modal, _Abstract2);
	
	  function Module_Modal(el, options) {
	    _classCallCheck(this, Module_Modal);
	
	    _get(Object.getPrototypeOf(Module_Modal.prototype), 'constructor', this).call(this, el, $.extend(true, {}, options), 'module');
	    console.log(this.options, 'KarthikOptions');
	    console.log(el, '$el');
	    this.initModule();
	  }
	
	  _createClass(Module_Modal, [{
	    key: 'initModule',
	    value: function initModule() {
	      this.initListeners();
	    }
	  }, {
	    key: 'initListeners',
	    value: function initListeners() {
	      var _this = this;
	      if (_this.getCookie("stemlearningpopup") === "") {
	        setTimeout(function () {
	          $(".c-modal").removeClass("c-modal__hidden");
	        }, _this.options.popupDelayTime);
	      }
	
	      //--Cancel Button Clicked
	      function onCancelPopup() {
	        $(".c-modal").fadeOut("fast");
	        _this.setCookie("stemlearningpopup", "clicked", 100000);
	      }
	
	      $(".c-modal .-icon_close, .c-modal .c-btn").on("click", onCancelPopup);
	    }
	  }]);
	
	  return Module_Modal;
	})(_systemAbstract2['default']);
	
	exports['default'] = Module_Modal;
	module.exports = exports['default'];

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	var Module_Tabs = (function (_Abstract2) {
	    _inherits(Module_Tabs, _Abstract2);
	
	    function Module_Tabs(el, options) {
	        _classCallCheck(this, Module_Tabs);
	
	        _get(Object.getPrototypeOf(Module_Tabs.prototype), "constructor", this).call(this, el, $.extend(true, {}, options), 'module');
	
	        this.initModule();
	    }
	
	    /********* Initialising ***************/
	
	    _createClass(Module_Tabs, [{
	        key: "initModule",
	        value: function initModule() {
	            // this.$mList = this.$el.closest(".m-list");
	            // this.$mListColumns = this.$el.closest(".m-list").find(".m-columns__columns");
	            // this.$mContainerList = this.$mList.find(".m-list__list");
	            // this.$elItemBtn = this.$el.find("a");
	            // this.$elItemSelect = this.$el.find("select")
	            this.initListener();
	        }
	    }, {
	        key: "initListener",
	        value: function initListener() {
	            // this.$el.on("click", "a", (e) => this.onItemClicked(e));
	            // this.$el.on("change", "select", (e) => this.onSelectBoxChanged(e));
	
	            this.onTabsItemClicked();
	        }
	    }, {
	        key: "onTabsItemClicked",
	        value: function onTabsItemClicked() {
	            $(".c-tabs > li > a").on("click", function (e) {
	                e.preventDefault();
	                var hash = $(this).attr('href');
	                //window.location.hash = 'tab-' + hash.replace('#', '');
	
	                if ($(this).hasClass("-active")) {
	                    //detection for current tab
	                    return;
	                } else {
	                    $(".c-tabs__content > .c-tabs__content-item").hide();
	                    $(".c-tabs > li > a").removeClass("-active");
	                    $(this).addClass("-active"); // Activate this
	                    $(hash).fadeIn(); // Show content for current tab
	                }
	            });
	
	            $(".c-tabs > li:first > a").trigger('click');
	
	            if (window.location.hash != '') {
	                $('.c-tabs > li > a[href="' + window.location.hash.replace('tab-', '') + '"]').trigger('click');
	                var $tabElements = $('.c-tabs');
	                $('html, body').animate({
	                    scrollTop: $tabElements.offset().top - 30
	                }, 1000);
	            }
	        }
	    }]);
	
	    return Module_Tabs;
	})(_systemAbstract2["default"]);
	
	exports["default"] = Module_Tabs;
	module.exports = exports["default"];

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	var Module_TwoColVerticallyStackedTiles = (function (_Abstract2) {
	    _inherits(Module_TwoColVerticallyStackedTiles, _Abstract2);
	
	    function Module_TwoColVerticallyStackedTiles(el, options) {
	        _classCallCheck(this, Module_TwoColVerticallyStackedTiles);
	
	        _get(Object.getPrototypeOf(Module_TwoColVerticallyStackedTiles.prototype), "constructor", this).call(this, el, $.extend(true, {}, options), 'module');
	        this.initialise();
	
	        var LAZY_LOAD_TILES_OFF_SCREEN = true;
	
	        this.orderedType = "";
	    }
	
	    _createClass(Module_TwoColVerticallyStackedTiles, [{
	        key: "initialise",
	        value: function initialise() {
	            this.cacheElements();
	            this.setOrderNumbersOnElements();
	            this.initialiseListeners();
	            this.reorderElements();
	        }
	    }, {
	        key: "setOrderNumbersOnElements",
	        value: function setOrderNumbersOnElements() {
	            this.$tileContent.find("> *").each(function (index, value) {
	                $(this).attr("data-index", index);
	            });
	        }
	    }, {
	        key: "cacheElements",
	        value: function cacheElements() {
	            this.$tileContent = this.$el.find(".m-two-col-vertically-stacked-tiles-content");
	            this.$firstContentContainer = this.$el.find(".-first-content-container");
	            this.$secondContentCotainer = this.$el.find(".-second-content-container");
	        }
	    }, {
	        key: "initialiseListeners",
	        value: function initialiseListeners() {
	            var _this = this;
	
	            $(window).resize(function (e) {
	                return _this.onWindowResized(e);
	            });
	            $("body").on('reorder-items', function () {
	                return _this.onReorderElementsEventTriggered();
	            });
	        }
	    }, {
	        key: "onWindowResized",
	        value: function onWindowResized(_event) {
	            this.reorderElements();
	        }
	    }, {
	        key: "onReorderElementsEventTriggered",
	        value: function onReorderElementsEventTriggered(_event) {
	            this.reorderElements(true);
	        }
	    }, {
	        key: "reorderElements",
	        value: function reorderElements(_forceReorder) {
	            if (typeof _forceReorder === "undefined") {
	                _forceReorder = false;
	            }
	
	            var desktopBreakpointSize = $("#bp-desktop").width();
	
	            var windowOuterWidth = $(window).outerWidth();
	
	            var bDesktopSizeAndNewColumnType = windowOuterWidth >= desktopBreakpointSize && (this.orderedType !== "two-col" || _forceReorder);
	            var bMobileSizeAndNewColumnType = windowOuterWidth < desktopBreakpointSize && (this.orderedType !== "one-col" || _forceReorder);
	
	            if (bDesktopSizeAndNewColumnType || bMobileSizeAndNewColumnType) {
	                this.$tileContent.append(this.$firstContentContainer.find(" > a").detach());
	                this.$tileContent.append(this.$secondContentCotainer.find(" > a").detach());
	                this.setTileContentInOriginalOrder();
	                var $tileItems = this.$tileContent.find(" > a");
	                var $dataResponsiveImages = $tileItems.find("[data-responsive-image]");
	                $dataResponsiveImages.removeClass("-defer-loading");
	
	                if (bDesktopSizeAndNewColumnType) {
	                    var context = this;
	                    var $nonHiddenItems = $tileItems.not('.-hide');
	
	                    $nonHiddenItems.each(function () {
	                        var $smallestTileContainer = context.getSmallestHeightTileContainer();
	                        $smallestTileContainer.append(this);
	                    });
	
	                    $tileItems.not(':not(.-hide)').each(function () {
	                        var $smallestTileContainer = context.getSmallestHeightTileContainer();
	                        $smallestTileContainer.append(this);
	                    });
	
	                    this.orderedType = "two-col";
	                } else if (bMobileSizeAndNewColumnType) {
	                    this.$firstContentContainer.append($tileItems);
	                    this.orderedType = "one-col";
	                }
	
	                $("body").trigger("responsive-image", { "$responsiveImageTargets": $dataResponsiveImages });
	            }
	        }
	    }, {
	        key: "setTileContentInOriginalOrder",
	        value: function setTileContentInOriginalOrder() {
	            var bAscendingOrder = this.$el.hasClass("-ascending-order");
	
	            var $detachedItems = this.$tileContent.find("> *").detach();
	            if (bAscendingOrder) {
	                $detachedItems.sort(function (a, b) {
	                    return +b.getAttribute("data-index") - +a.getAttribute("data-index");
	                }).appendTo(this.$tileContent);
	            } else {
	                $detachedItems.sort(function (a, b) {
	                    return +a.getAttribute("data-index") - +b.getAttribute("data-index");
	                }).appendTo(this.$tileContent);
	            }
	        }
	    }, {
	        key: "getFirstContainerTileHeight",
	        value: function getFirstContainerTileHeight() {
	            return this.getHeightOfTilesInContainer(this.$firstContentContainer);
	        }
	    }, {
	        key: "getSecondContainerTileHeight",
	        value: function getSecondContainerTileHeight() {
	            return this.getHeightOfTilesInContainer(this.$secondContentCotainer);
	        }
	    }, {
	        key: "getHeightOfTilesInContainer",
	        value: function getHeightOfTilesInContainer(_$container) {
	            var $tiles = _$container.find("> a");
	            var height = 0;
	            $tiles.each(function () {
	                height += $(this).height();
	            });
	
	            return height;
	        }
	    }, {
	        key: "getSmallestHeightTileContainer",
	        value: function getSmallestHeightTileContainer() {
	            if (this.getFirstContainerTileHeight() <= this.getSecondContainerTileHeight()) {
	                return this.$firstContentContainer;
	            } else {
	                return this.$secondContentCotainer;
	            }
	        }
	    }]);
	
	    return Module_TwoColVerticallyStackedTiles;
	})(_systemAbstract2["default"]);
	
	exports["default"] = Module_TwoColVerticallyStackedTiles;
	module.exports = exports["default"];

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	//No longer using the youtube API, too much can go wrong to override the theme
	//and even using it we cant override the play / pause buttons *sad face*
	
	//A global loader to get the youtube JavascriptAPI loaded
	//This only needs to run once, so we run it outside of an instantiated class
	// var onYoutubeloadedCallbacks = [];
	// var bYoutubeAPILoaded = false;
	// $.getScript("//www.youtube.com/player_api", function()
	// {
	//     var yt_int = setInterval(function()
	//     {
	//         if(typeof YT === "object")
	//         {
	//             clearInterval(yt_int);
	//             for(var i =0 ; i < onYoutubeloadedCallbacks.length; ++i)
	//             {
	//             	onYoutubeloadedCallbacks[i]();
	//             }
	//             onYoutubeloadedCallbacks = null;
	//         }
	//     },500);
	// });
	
	var Module_VideoTile = (function (_Abstract2) {
		_inherits(Module_VideoTile, _Abstract2);
	
		function Module_VideoTile(el, options) {
			_classCallCheck(this, Module_VideoTile);
	
			_get(Object.getPrototypeOf(Module_VideoTile.prototype), "constructor", this).call(this, el, $.extend(true, {}, options), 'module');
			console.log(options);
	
			this.bIsIOSDevice = navigator.userAgent.match(/(iPod|iPhone|iPad)/);
			this.bIsYoutubeVideo = this.$el.find(".youtube-player").length;
			this.youtubeID = "";
			// if(this.bIsYoutubeVideo)
			// {
			// 	return;//dont do anything just yet
			// }
			if (this.bIsYoutubeVideo) {
				return;
			}
			this.initModule();
	
			this.HIDE_VIDEO_CONTROLS_TIME_MILLISECONDS = 2000;
			this.VIDEO_DURATION_UPDATE_TIME = 1000 / 30; //How often the scrub bar updates when the video is playing
		}
	
		/***** Initialising methods *******************/
	
		_createClass(Module_VideoTile, [{
			key: "initModule",
			value: function initModule() {
				this.initClassVariables();
				this.initListeners();
			}
		}, {
			key: "initClassVariables",
			value: function initClassVariables() {
				this.$video = this.$el.find('video');
				this.video = null;
				// this.$youtubeVideoIframe = null;
				this.$youtubeVideoIframe = this.$el.find('.youtube-player');
				this.bIsYoutubeVideo = this.$youtubeVideoIframe !== 0;
				this.youtubePlayerInstance = null;
				this.youtubePlayerState = null;
				this.onDocumentBoundMouseMoveHandler = this.onDocumentMouseMoveHandler.bind(this);
	
				this.initialiseVideoControls();
	
				if (this.$video.length) {
					this.initialiseHTML5Video();
				} else if (this.bIsYoutubeVideo) {
					this.youtubeID = this.$el.find("[name='youtube-id']").val();
					this.initialiseYoutubeImage();
					this.initialiseYoutubeVideo();
				} else {
					return;
				}
			}
		}, {
			key: "initialiseVideoControls",
			value: function initialiseVideoControls() {
				this.isScrubbing = false;
				this.hideControlsTimer = null;
				this.scrubBarTimer = null;
				this.youtubeCountdownTimer = null;
				this.$videoContainer = this.$el.find('.video-ctn');
				this.$videoControlsContainer = this.$el.find('.video-controls');
				this.$videoControlsPlayButton = this.$el.find('.video-controls-play-btn');
				this.$videoControlsPauseButton = this.$el.find('.video-controls-pause-btn');
				this.$videoControlsScrubBarContainer = this.$el.find('.video-controls-scrub-bar-container');
				this.$videoControlsScrubBarDuration = this.$el.find('.video-controls-scrub-bar-duration');
				this.$videoControlsTime = this.$el.find('.video-controls-time');
				this.$videoControlsFullScreen = this.$el.find('.video-controls-full-screen');
				this.$videoControlsExitFullScreen = this.$el.find('.video-controls-exit-full-screen');
			}
		}, {
			key: "initialiseHTML5Video",
			value: function initialiseHTML5Video() {
				this.video = this.$video[0];
	
				if (this.bIsIOSDevice) {
					this.video.load();
				}
			}
	
			/***** Youtube Callbacks and methods *******************/
	
		}, {
			key: "initialiseYoutubeImage",
			value: function initialiseYoutubeImage() {
				// this.$el.find(".video-ctn").css("background-image","url('http://img.youtube.com/vi/"+this.youtubeID+"/maxresdefault.jpg')");
			}
		}, {
			key: "initialiseYoutubeVideo",
			value: function initialiseYoutubeVideo() {
				var _this = this;
	
				var youtubeEmbedURL = "https://www.youtube.com/embed/" + this.youtubeID + "?version=3&amp;enablejsapi=1&amp;autoplay=0&amp;autohide=1&amp;showinfo=0&amp;modestbranding=1&amp;rel=0&amp;controls=0";
	
				if (this.bIsIOSDevice) {
					youtubeEmbedURL = "https://www.youtube.com/embed/" + this.youtubeID;
					// this.$el.find(".youtube-player-overlay").remove();
					this.$el.find(".video-controls").remove();
					this.$el.find(".video-controls-time").remove();
					this.$el.find(".video-controls-scrub-bar-container").remove();
				}
	
				this.$youtubeVideoIframe.attr("src", youtubeEmbedURL);
	
				if (bYoutubeAPILoaded) {
					this.onYoutubeAPILoaded();
				} else {
					onYoutubeloadedCallbacks.push(function () {
						return _this.onYoutubeAPILoaded();
					});
				}
			}
		}, {
			key: "onYoutubeAPILoaded",
			value: function onYoutubeAPILoaded() {
				var _this2 = this;
	
				console.log("onYoutubeAPILoaded");
				// this.video.addEventListener("timeupdate", (e)=> this.onVideoTimeUpdate(e));
	
				var player = new YT.Player(this.$youtubeVideoIframe[0], {
					events: {
						'onReady': function onReady(e) {
							return _this2.onYoutubePlayerInstanceReady(e);
						},
						'onStateChange': function onStateChange(e) {
							return _this2.onYoutubePlayerInstanceStateChange(e);
						}
	
					}
				});
			}
		}, {
			key: "onYoutubePlayerInstanceReady",
			value: function onYoutubePlayerInstanceReady(event) {
				this.youtubePlayerInstance = event.target;
			}
		}, {
			key: "onYoutubePlayerInstanceStateChange",
			value: function onYoutubePlayerInstanceStateChange(event) {
				var _this3 = this;
	
				this.youtubePlayerState = event.data;
				switch (event.data) {
					case YT.PlayerState.ENDED:
					case YT.PlayerState.PAUSED:
						{
							this.onVideoPaused();
							this.updateCountDownTimer();
							window.clearInterval(this.youtubeCountdownTimer);
							this.youtubeCountdownTimer = null;
	
							break;
						}
	
					case YT.PlayerState.BUFFERING:
						{
							break;
						}
	
					case YT.PlayerState.PLAYING:
					case YT.PlayerState.CUED:
						{
							this.$videoContainer.css("background-image", "none");
							this.$youtubeVideoIframe.removeClass("-hide");
	
							this.onVideoPlaying();
							this.youtubeCountdownTimer = window.setInterval(function () {
								return _this3.updateCountDownTimer();
							}, 1000);
							break;
						}
				}
			}
	
			/***** Initialising Event Listeners *******************/
	
		}, {
			key: "initListeners",
			value: function initListeners() {
				var _this4 = this;
	
				document.addEventListener("fullscreenchange", function (e) {
					return _this4.onFullScreenChange(e);
				});
				document.addEventListener("webkitfullscreenchange", function (e) {
					return _this4.onFullScreenChange(e);
				});
				document.addEventListener("mozfullscreenchange", function (e) {
					return _this4.onFullScreenChange(e);
				});
				document.addEventListener("MSFullscreenChange", function (e) {
					return _this4.onFullScreenChange(e);
				});
				this.$videoControlsFullScreen.click(function (e) {
					return _this4.onFullScreenClicked(e);
				});
				this.$videoControlsExitFullScreen.click(function (e) {
					return _this4.onExitFullScreenClicked(e);
				});
				this.$videoContainer.click(function (e) {
					return _this4.onVideoContainerClicked(e);
				});
				this.$videoContainer.mousemove(function (e) {
					return _this4.onMouseMoveOnVideoContainer(e);
				});
	
				if (this.video) {
					$(document).mouseleave(function () {
						_this4.isScrubbing = false;
						$(document).off('mousemove', _this4.onDocumentBoundMouseMoveHandler);
						_this4.setCurrentTimeBasedOffScrubBarPosition();
					});
	
					$(document).mouseup(function () {
						_this4.isScrubbing = false;
						$(document).off('mousemove', _this4.onDocumentBoundMouseMoveHandler);
						_this4.setCurrentTimeBasedOffScrubBarPosition();
					});
					this.$videoContainer.on('mousedown', function (e) {
						return _this4.onHTML5VideoContainerMouseDown(e);
					});
					this.video.addEventListener("play", function (e) {
						return _this4.onVideoPlaying(e);
					});
					this.video.addEventListener("pause", function (e) {
						return _this4.onVideoPaused(e);
					});
					this.video.addEventListener("timeupdate", function (e) {
						return _this4.onVideoTimeUpdate(e);
					});
				} else if (this.bIsYoutubeVideo) {
					// this.$el.find(".youtube-player-overlay").click((e) => this.preventDefaultAndToggleVideo(e));
					// this.$el.find(".youtube-player-overlay").on("touchstart",(e) => this.preventDefaultAndToggleVideo(e));
					// this.$el.find(".youtube-player-overlay").mousedown((e) => this.preventDefault(e));
				}
			}
		}, {
			key: "preventDefaultAndToggleVideo",
			value: function preventDefaultAndToggleVideo(e) {
				this.preventDefault(e);
				this.toggleVideoPlayState();
			}
		}, {
			key: "preventDefault",
			value: function preventDefault(e) {
				if (!e.preventDefault) {
					//IE quirks
					e.returnValue = false;
					e.cancelBubble = true;
				}
				e.preventDefault();
				e.stopPropagation();
			}
	
			/***** Responding to Full Screen Change Events *******************/
	
		}, {
			key: "onFullScreenChange",
			value: function onFullScreenChange(e) {
				// console.log(e);
				if (this.isCurrentlyFullscreen()) {
					this.showCancelFullScreenButtonHideGoFullScreenButton();
				} else {
					this.showGoFullScreenButtonHideCancelFullScreenButton();
				}
			}
		}, {
			key: "isCurrentlyFullscreen",
			value: function isCurrentlyFullscreen() {
				var bIsFullScreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen || typeof document.msFullscreenElement !== 'undefined' && document.msFullscreenElement != null;
				return bIsFullScreen;
			}
	
			/***** Responding to Native HTML Video Events *******************/
	
		}, {
			key: "onVideoPlaying",
			value: function onVideoPlaying(e) {
				console.log('onVideoPlaying');
				this.showPauseButtonHidePlayButton();
				this.setHideControlsTimer();
				this.setScrubBarTimer();
			}
		}, {
			key: "onVideoPaused",
			value: function onVideoPaused(e) {
				console.log('onVideoPaused');
				this.showPlayButtonHidePauseButton();
				this.showVideoControls();
				this.clearScrubBarTimer();
			}
	
			//Note, we only use this video for the clock timer
			//As using this for the scrub bar, the update rate is far too slow
		}, {
			key: "onVideoTimeUpdate",
			value: function onVideoTimeUpdate(e) {
				this.updateCountDownTimer();
			}
	
			/***** Responding to Mouse Movement Events *******************/
	
		}, {
			key: "onMouseMoveOnVideo",
			value: function onMouseMoveOnVideo(e) {
				this.showVideoControls();
			}
	
			// onMouseMoveOnVideoControlsContainer()
			// {
			// 	if(!this.video.playing)
			// 	{
			// 		return;
			// 	}
			// 	console.log('onMouseMoveOnVideoControlsContainer');
			// 	this.showVideoControls();
			// }
	
		}, {
			key: "onMouseMoveOnVideoContainer",
			value: function onMouseMoveOnVideoContainer(mouseEvent) {
				// var x = mouseEvent.pageX - this.$el.offset().left;
				var mouseY = mouseEvent.pageY - this.$el.find('.video-ctn').offset().top;
				//check if they're at a percentage from the bottom
	
				var heightOfContainer = this.$el.find('.video-ctn').height();
	
				var percentageOfPosition = mouseY / heightOfContainer * 100;
				if (percentageOfPosition >= 90) {
					this.$el.addClass('larger-footer-controls');
				} else {
					this.$el.removeClass('larger-footer-controls');
				}
	
				// console.log('onMouseMoveOnVideoContainer');
				this.showVideoControls();
			}
		}, {
			key: "onDocumentMouseMoveHandler",
			value: function onDocumentMouseMoveHandler(mouseEvent) {
				var percentageX = this.getMousePercentageOnContainerFromEvent(mouseEvent);
				this.setPercentageOfScrubBar(percentageX);
			}
	
			/***** Video State Changes *******************/
		}, {
			key: "setCurrentTimeBasedOffScrubBarPosition",
			value: function setCurrentTimeBasedOffScrubBarPosition() {
				//This is 0-1 not 0-100
				var scrubDecimalFraction = this.$videoControlsScrubBarDuration.width() / this.$videoControlsScrubBarContainer.width();
				this.video.currentTime = this.video.duration * scrubDecimalFraction;
			}
	
			/***** Responding to Click Events *******************/
	
		}, {
			key: "onHTML5VideoContainerMouseDown",
			value: function onHTML5VideoContainerMouseDown(mouseEvent) {
				var $target = $(mouseEvent.target);
				if (!this.isHTML5VideoAndClickedWithinScrubber(mouseEvent)) {
					return;
				}
	
				if (this.isScrubbing) {
					return;
				}
	
				this.isScrubbing = true;
				$(document).on('mousemove', this.onDocumentBoundMouseMoveHandler);
			}
		}, {
			key: "onVideoContainerClicked",
			value: function onVideoContainerClicked(mouseEvent) {
				if (this.isScrubbing) {
					return;
				}
				console.log("onVideoContainerClicked");
				if (this.$el.hasClass("-fullscreen-on-play") && this.isVideoPaused()) {
					this.onFullScreenClicked();
				}
	
				if (this.isHTML5VideoAndClickedWithinScrubber(mouseEvent)) {
					var percentageX = this.getMousePercentageOnContainerFromEvent(mouseEvent);
					this.video.currentTime = this.video.duration * (percentageX / 100);
					this.updateCountDownTimer();
					this.onScrubBarTick();
				} else {
					this.toggleVideoPlayState();
				}
			}
		}, {
			key: "getMousePercentageOnContainerFromEvent",
			value: function getMousePercentageOnContainerFromEvent(mouseEvent) {
				var widthOfContainer = this.$el.find('.video-ctn').width();
				var mouseX = mouseEvent.pageX - this.$el.find('.video-ctn').offset().left;
				var percentageX = mouseX / widthOfContainer;
				if (percentageX < 0) {
					percentageX = 0;
				} else if (percentageX > 1) {
					percentageX = 1;
				}
	
				percentageX *= 100;
	
				return percentageX;
			}
		}, {
			key: "isHTML5VideoAndClickedWithinScrubber",
			value: function isHTML5VideoAndClickedWithinScrubber(mouseEvent) {
				if (!this.video) {
					return;
				}
	
				var $clickedTarget = $(mouseEvent.target);
				var mouseY = mouseEvent.pageY - this.$el.find('.video-ctn').offset().top;
				var heightOfContainer = this.$el.find('.video-ctn').height();
				var heightOfScrubber = this.$el.find('.video-controls-scrub-bar-container').height();
				var clickedWithinScrubBar = mouseY >= heightOfContainer - heightOfScrubber;
				return clickedWithinScrubBar;
			}
		}, {
			key: "toggleVideoPlayState",
			value: function toggleVideoPlayState() {
				if (this.video) {
					if (this.isVideoPaused()) {
						this.video.play();
					} else {
						this.video.pause();
					}
				} else if (this.youtubePlayerInstance) {
					if (this.isVideoPaused()) {
						this.youtubePlayerInstance.playVideo();
					} else {
						this.youtubePlayerInstance.pauseVideo();
					}
				}
			}
		}, {
			key: "onFullScreenClicked",
			value: function onFullScreenClicked(e) {
				//Stop propagation so the click event on the video container doesnt get called
				if (typeof e !== "undefined") {
					e.preventDefault();
					e.stopPropagation();
				}
	
				if (!this.$video.length) {
					return;
				}
	
				var videoContainer = this.$el.find(".video-ctn")[0];
				if (videoContainer.requestFullscreen) {
					videoContainer.requestFullscreen();
				} else if (videoContainer.mozRequestFullScreen) {
					videoContainer.mozRequestFullScreen();
				} else if (videoContainer.webkitRequestFullscreen) {
					videoContainer.webkitRequestFullscreen();
				} else if (videoContainer.msRequestFullscreen) {
					videoContainer.msRequestFullscreen();
				} else if (typeof this.$video[0].webkitEnterFullscreen !== "undefined") {
					this.$video[0].webkitEnterFullscreen();
				}
			}
		}, {
			key: "onExitFullScreenClicked",
			value: function onExitFullScreenClicked(e) {
				e.preventDefault();
				e.stopPropagation();
				// exit full-screen
				if (document.exitFullscreen) {
					document.exitFullscreen();
				} else if (document.webkitExitFullscreen) {
					document.webkitExitFullscreen();
				} else if (document.mozCancelFullScreen) {
					document.mozCancelFullScreen();
				} else if (document.msExitFullscreen) {
					document.msExitFullscreen();
				}
			}
	
			/***** Changing button states *******************/
	
		}, {
			key: "showPlayButtonHidePauseButton",
			value: function showPlayButtonHidePauseButton() {
				this.$videoControlsPlayButton.removeClass("-hide");
				this.$videoControlsPauseButton.addClass("-hide");
			}
		}, {
			key: "showPauseButtonHidePlayButton",
			value: function showPauseButtonHidePlayButton() {
				this.$videoControlsPauseButton.removeClass("-hide");
				this.$videoControlsPlayButton.addClass("-hide");
			}
		}, {
			key: "showGoFullScreenButtonHideCancelFullScreenButton",
			value: function showGoFullScreenButtonHideCancelFullScreenButton() {
				this.$videoControlsFullScreen.removeClass("-hide");
				this.$videoControlsExitFullScreen.addClass("-hide");
			}
		}, {
			key: "showCancelFullScreenButtonHideGoFullScreenButton",
			value: function showCancelFullScreenButtonHideGoFullScreenButton() {
				this.$videoControlsExitFullScreen.removeClass("-hide");
				this.$videoControlsFullScreen.addClass("-hide");
			}
	
			/***** Hiding and showing the video controls container timer *******************/
	
		}, {
			key: "updateCountDownTimer",
			value: function updateCountDownTimer() {
	
				var videoDuration = this.video ? this.video.duration : this.youtubePlayerInstance.getDuration();
				var videoCurrentTime = this.video ? this.video.currentTime : this.youtubePlayerInstance.getCurrentTime();
	
				var totalSecondsRemaining = videoDuration - videoCurrentTime;
	
				var minutesRemaining = Math.floor(totalSecondsRemaining / 60);
				var secondsRemaining = Math.floor(totalSecondsRemaining % 60);
	
				if (minutesRemaining < 10) {
					minutesRemaining = "0" + minutesRemaining;
				}
	
				if (secondsRemaining < 10) {
					secondsRemaining = "0" + secondsRemaining;
				}
	
				var timeText = minutesRemaining + ":" + secondsRemaining;
				this.$videoControlsTime.text(timeText);
			}
	
			/***** Hiding and showing the video controls container timer *******************/
	
		}, {
			key: "isVideoPaused",
			value: function isVideoPaused() {
				if (this.video) {
					return this.video.paused;
				} else if (this.youtubePlayerInstance) {
					return this.youtubePlayerState === null || this.youtubePlayerState === YT.PlayerState.ENDED || this.youtubePlayerState === YT.PlayerState.PAUSED;
				}
				return false;
			}
		}, {
			key: "clearHideControlsTimer",
			value: function clearHideControlsTimer() {
				if (this.hideControlsTimer === null) {
					return;
				}
	
				window.clearTimeout(this.hideControlsTimer);
				this.hideControlsTimer = null;
			}
		}, {
			key: "setHideControlsTimer",
			value: function setHideControlsTimer() {
				var _this5 = this;
	
				this.clearHideControlsTimer();
				this.hideControlsTimer = window.setTimeout(function () {
					return _this5.onHideControlsTimerExpired();
				}, this.HIDE_VIDEO_CONTROLS_TIME_MILLISECONDS);
			}
		}, {
			key: "onHideControlsTimerExpired",
			value: function onHideControlsTimerExpired() {
				this.clearHideControlsTimer();
				this.hideVideoControls();
			}
		}, {
			key: "hideVideoControls",
			value: function hideVideoControls() {
				if (this.isVideoPaused()) {
					return;
				}
	
				this.$videoControlsContainer.stop(true).fadeOut();
			}
		}, {
			key: "showVideoControls",
			value: function showVideoControls() {
				this.setHideControlsTimer();
				this.$videoControlsContainer.stop(true).fadeIn();
			}
	
			/***** Scrub Bar timer *******************/
	
		}, {
			key: "clearScrubBarTimer",
			value: function clearScrubBarTimer() {
				if (this.scrubBarTimer === null) {
					return;
				}
	
				window.clearInterval(this.scrubBarTimer);
				this.scrubBarTimer = null;
			}
		}, {
			key: "setScrubBarTimer",
			value: function setScrubBarTimer() {
				var _this6 = this;
	
				this.clearScrubBarTimer();
				this.scrubBarTimer = window.setInterval(function () {
					return _this6.onScrubBarTick();
				}, this.VIDEO_DURATION_UPDATE_TIME);
			}
		}, {
			key: "onScrubBarTick",
			value: function onScrubBarTick() {
				if (this.isScrubbing) {
					//If it's scrubbing then dont update the scrub percentage as it may interrupt
					return;
				}
				var videoCurrentTime = this.video ? this.video.currentTime : this.youtubePlayerInstance.getCurrentTime();
				var videoDuration = this.video ? this.video.duration : this.youtubePlayerInstance.getDuration();
				var percentageDuration = videoCurrentTime / videoDuration * 100;
				this.setPercentageOfScrubBar(percentageDuration);
			}
	
			/**
	   * 
	   * @param {number} percentageDuration The percentage width of the timer scrubber
	   */
		}, {
			key: "setPercentageOfScrubBar",
			value: function setPercentageOfScrubBar(percentageDuration) {
				this.$videoControlsScrubBarDuration.css("width", percentageDuration + "%");
			}
		}]);
	
		return Module_VideoTile;
	})(_systemAbstract2["default"]);
	
	exports["default"] = Module_VideoTile;
	module.exports = exports["default"];

/***/ }
]);


/** WEBPACK FOOTER **
 ** 1.1.js
 **/